<template>
  <!-- CPAP 導入申込み -->
  <div id="CpapRequest">
    <section>
      <div id="container-center">
        <form>
        <h1 v-if="temp" style="" class="title has-text-centered printTarget">CPAP 仮持出申込み</h1>
        <h1 v-else-if="isInstrument" style="" class="title has-text-centered printTarget">CPAP 預託機処方申込み</h1>
        <h1 v-else style="" class="title has-text-centered printTarget">CPAP 処方申込み</h1>
        <div>
          <b-steps v-model="activeStep" :animated="true" :rounded="true" :has-navigation="false" label-position="bottom">
            <b-step-item step="1" label="利用規約" icon="comment-alert-outline" v-if="needAgree">
              <div id="item-contens">
                <div class="request-title">
                  <b-button class="is-primary" style="float:left;" icon-left="home" @click.prevent="goHome">ホーム画面 </b-button>
                  <b-button class="is-primary" style="float: right" icon-right="chevron-double-right" :disabled="!isChecked" @click.prevent="Forward">次へ</b-button>
                  <span>以下の利用規約に同意のうえ、申込みを行ってください。</span>
                </div>
                <div v-if="isHospitalNewOrder()" style="margin-bottom: 1em; font-size: 18px" >
                  <router-link :to="{name:'CpapRequestDraftView', params:{}}" style="color: #2255ff; font-weight: bold;">
                    保存中（申込み未完了）の処方作成はこちら
                  </router-link>
                </div>
                <div class="card-content margin-top">
                  <span style="font-size:20px;">利用規約</span>
                  <a @click="download"><b-icon style="margin-top:3px;" icon="file-download-outline"/></a>
                  <table>
                    <tr><td><textarea readonly class="cautionArea noresize" v-model="agreement" /></td></tr>
                    <tr>
                      <td>
                        <div style="text-align: center; color: black">
                          「<a :href="getUrlRentalCondition()" target="_blank" rel="noopener noreferrer">レンタルの一般条件</a>」は<a :href="getUrlRentalCondition()" target="_blank" rel="noopener noreferrer" style="font-weight: bold;color:blue">こちら</a>を参照してください。 「<a :href="getUrlPrivacyPolicy()" target="_blank" rel="noopener noreferrer">プライバシー規則</a>」は<a :href="getUrlPrivacyPolicy()" target="_blank" rel="noopener noreferrer" style="font-weight: bold;color:blue">こちら</a>を参照してください。
                        </div>
                      </td>
                    </tr>
                    <tr><td><div style="text-align: center;"></div></td></tr>
                    <tr><td><div style="text-align: center;"><b-checkbox class="cstmCheckBox" v-model="isChecked" :disabled="!canAgree">利用規約に同意のうえ、申込みを行う。</b-checkbox></div></td></tr>
                  </table>
                </div>
              </div>
            </b-step-item>
            <b-step-item step="2" label="基本情報" icon="clipboard-edit-outline">
              <div id="item-contens" v-bind:key="renderKey">
                <div class="request-title">
                  <b-button v-if="false" class="is-primary" style="float:left;" icon-left="chevron-double-left" @click.prevent="Backward">戻る</b-button>
                  <b-button v-else class="is-primary" style="float:left;" icon-left="home" @click.prevent="goHome">ホーム画面 </b-button>
                  <b-button class="is-primary" style="float:right;" icon-right="chevron-double-right" :disabled="!isHospitalAgree||!isPatientAgree" @click.prevent="Forward">次へ</b-button>
                  <span>申込み内容を入力してください。</span>
                  <span v-if="cpapBeforeRequestDetail">
                    <b-button v-if="!resume" class="is-primary" style="width:180px;" @click="cpapPreviousRequestCopy">デフォルト設定値反映</b-button>
                  </span>
                </div>
                <div class="card-content margin-top">
                  <span style="font-size:20px;">医療機関情報</span>
                  <table>
                    <tr v-if="!isHospital && !isDealer"><th>指示日<span class="require"/></th><td><input type="date" v-model="reqParams.instructionDate" class="2" :name="'指示日'" validate="required|date" style="width:150px;"/></td></tr>
                    <tr><th>医療機関名<span class="require" v-if="isDealer || isHonsha || isAdmin || isSalesOffice"/></th>
                      <td>
                        <template v-if="isDealer || isHonsha || isAdmin || isSalesOffice">
                          <input type="text" style="width:730px;" v-model="reqParams.medicalInstitutionName" class="2" name="医療機関名" validate="required" disabled />
                          <b-button v-if="!cancelResume" style="margin-left:10px; width:150px; height:27px;" @click="organizationModalActive=true">医療機関選択</b-button>
                        </template>
                        <template v-else>{{reqParams.medicalInstitutionName}}</template>
                      </td>
                    </tr>
                    <tr><th>医師名<span class="require"/></th><td><input type="text" v-model="reqParams.doctorName" maxlength="105" id="doctorName" :class="`${reqParams.existingFlag ? 'resumeExisting' : '2'}`" name="医師名" validate="required"/></td></tr>
                    <tr><th>事務担当者名</th><td><input type="text"  v-model="reqParams.clerkName" maxlength="100"/></td></tr>
                    <tr v-if="isHonsha || isAdmin || isSalesOffice"><th>コメント</th><td>{{reqParams.note}}</td></tr>
                    <template v-if="isDealer">
                      <tr><th>医療機関メールアドレス</th><td><b-checkbox class="cstmCheckBox" v-model="reqParams.mailNotification">申込み内容を医療機関にメールで通知する。</b-checkbox></td></tr>
                      <tr v-if="reqParams.mailNotification"><th></th><td><input type="text" v-model="reqParams.hospitalMail" maxlength="256" placeholder="例）example@example.com" class="2" name="医療機関メールアドレス" validate="mail|required"></td></tr>
                    </template>
                  </table>
                  <!-- 患者情報 -->
                  <span style="font-size:20px;">患者情報</span>
                  <table>
                    <tr><th>診察券ID（患者ID）<span class="require" /></th><td><input type="text" v-model="reqParams.patient.patientRegistrationCard" maxlength="50" id="patientRegistrationCard" :class="`${reqParams.existingFlag ? 'resumeExisting' : '2'}`" :name="'診察券ID（患者ID）'" validate="required" /></td></tr>
                    <tr><th>患者名<span class="require" /></th><td><input type="text" style="margin-right: 5px; width: 446px !important;" placeholder="姓" v-model="reqParams.patient.patientFamilyName" class="2" :name="'患者名(姓)'" validate="required" maxlength="49"/><input type="text" style="width: 446px !important;" placeholder="名" v-model="reqParams.patient.patientFirstName" class="2" :name="'患者名(名)'" validate="required" maxlength="49" @blur="focusLostPatientFirstName()"/></td></tr>
                    <tr><th>患者名（カナ）<span class="require" /></th><td><input type="text" style="margin-right: 5px; width: 446px !important;" placeholder="セイ" v-model="reqParams.patient.patientFamilyNameKana" class="2" :name="'患者名カナ(セイ)'" validate="kana|required" maxlength="49"/><input type="text" style="width: 446px !important;" placeholder="メイ" v-model="reqParams.patient.patientFirstNameKana" class="2" :name="'患者名カナ(メイ)'" validate="kana|required" maxlength="49"/></td></tr>
                    <tr><th>性別<span class="require" /></th><td>
                      <div class="block">
                        <b-radio size="is-small" v-model="reqParams.patient.gender" native-value="-">-</b-radio>
                        <b-radio size="is-small" v-model="reqParams.patient.gender" native-value="男">男</b-radio>
                        <b-radio size="is-small" v-model="reqParams.patient.gender" native-value="女">女</b-radio>
                      </div></td>
                    </tr>
                    <tr><th>生年月日<span class="require"/></th><td><input type="date" v-model="reqParams.patient.birthday" :input="inputBirthday(reqParams.patient.birthday)" class="2" :name="'患者の生年月日'" validate="required|date|birthDay" :max="yyyy_hyp_MM_hyp_dd(new Date())" style="width:150px;"/><span v-if="reqParams.patient.birthday" style="margin-left:10px;">{{reqParams.patient.japaneseCalendar}}</span></td></tr>
                    <tr><th>年齢</th><td><input type="text" disabled v-model="reqParams.patient.age"/></td></tr>
                    <tr>
                      <th>
                        郵便番号<span class="require"/>
                      </th>
                      <td>
                        <input
                          v-model="reqParams.patient.zip"
                          type="text"
                          maxlength="7"
                          style="width: 270px"
                          class="2"
                          :class="{ 'border-red': invalidPostcode }"
                          name="患者の郵便番号"
                          validate="required|numeric"
                          :placeholder="postcodePlaceholder"
                        />
                        <b-button
                          style="margin-left: 10px; width: 150px; height: 27px"
                          v-on:click="patientAddressSearch(reqParams.patient.zip)"
                        >
                          郵便番号検索
                        </b-button>
                        <div v-show="invalidPostcode" class="text-red">{{ invalidNumberMessage }}</div>
                      </td>
                    </tr>
                    <tr><th>住所<span class="require"/></th><td><input type="text" v-model="reqParams.patient.address" maxlength="256" class="2" :name="'患者の住所'" validate="required"/></td></tr>
                    <tr><th>住所（丁目、番地）<span class="require"/></th><td><input type="text" v-model="reqParams.patient.address1" maxlength="256" class="2" :name="'患者の住所（丁目、番地）'" validate="required"/></td></tr>
                    <tr><th>住所（建物名、号室）</th><td><input type="text" v-model="reqParams.patient.address2" maxlength="256"/></td></tr>
                    <tr v-if="!isInstrument"><th>納品先宛名<span class="require"/></th><td><input type="text" v-model="reqParams.patient.receiverName" maxlength="100" class="2" :name="'納品先宛名'" validate="required"/></td></tr>
                    <tr v-if="!isInstrument && !isDealer && !isHospital" style="height:15px;"><td></td><td style="font-size:11px; color:red; padding:0px;">川越出荷時はこの宛名を使用しますので、誤りがないように必ず確認してください。</td></tr>
                    <tr>
                      <th>
                        連絡先（携帯電話）
                      </th>
                      <td>
                        <input
                          type="text"
                          v-model="reqParams.patient.mobilePhone"
                          maxlength="11"
                          id="mobilePhone"
                          class="2"
                          :class="{'border-red': invalidMobilePhoneNumber}"
                          name="連絡先（携帯電話）"
                          validate="numeric"
                          :placeholder="phonePlaceholder"
                        />
                        <div v-show="invalidMobilePhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        連絡（自宅・その他）
                      </th>
                      <td>
                        <input
                          type="text"
                          v-model="reqParams.patient.phoneNumber"
                          maxlength="11"
                          id="phoneNumber"
                          class="2"
                          :class="{'border-red': invalidPhoneNumber}"
                          validate="numeric"
                          name="連絡（自宅・その他）"
                          :placeholder="phonePlaceholder"
                        />
                        <div v-show="invalidPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
                      </td>
                    </tr>
                    <tr><th>フォローアップコール<span class="require"/></th>
                      <td>
                        <div>
                          <b-radio class="td_radio" name="followUpCall" v-model="reqParams.patient.followUpCall" :native-value="true">する</b-radio>
                          <b-radio class="td_radio" name="followUpCall" v-model="reqParams.patient.followUpCall" :native-value="false">しない</b-radio>
                        </div>
                      </td>
                    </tr>
                    <tr><th>病名</th>
                      <td>
                        <input type="text" v-model="reqParams.patient.disease" maxlength="256"/>
                      </td>
                    </tr>
                    <tr><th>感染症</th><td>
                      <select v-model="reqParams.patient.infection">
                        <option value=""/>
                        <option value="0">無し</option>
                        <option value="1">MRSA</option>
                        <option value="2">HCV</option>
                        <option value="3">HBV</option>
                        <option value="4">Wa</option>
                        <option value="5">その他</option>
                      </select>
                    </td></tr>
                    <tr><th>感染症名(その他)<span class="require" v-if="reqParams.patient.infection=='5'"/></th><td><input type="text" v-model="reqParams.patient.infectionName" maxlength="256" class="2" :name="'感染症名(その他)'" :validate="`${reqParams.patient.infection=='5' ? 'required' : ''}`"/></td></tr>
                    <tr><th>地域医療連携施設名</th><td><input type="text" v-model="reqParams.patient.hospitalName" maxlength="256" /></td></tr>
                    <tr><th>地域医療連携施設　医師名</th><td><input type="text" v-model="reqParams.patient.doctorName" maxlength="105"/></td></tr>
                    <template v-if="isDealer">
                      <tr/>
                      <tr>
                        <th/><td><b-checkbox class="cstmCheckBox" v-model="isHospitalAgree">申請者がCPAPの申込みを行うことについて、該当医療機関の同意を取得しています。</b-checkbox></td>
                      </tr>
                    </template>
                    <tr v-if="isHospital || isDealer">
                      <th/><td><b-checkbox class="cstmCheckBox" v-model="isPatientAgree">保守目的で個人情報をフィリップスと共有することについて、該当患者の同意を取得しています。</b-checkbox></td>
                    </tr>
                  </table>
                </div>
              </div>
            </b-step-item>
            <b-step-item step="3" label="装置情報" icon="clipboard-pulse-outline">
              <div id="item-contens">
                <div class="request-title">
                  <b-button class="is-primary" style="float:left;" icon-left="chevron-double-left" @click.prevent="Backward">前へ</b-button>
                  <span>装置情報を入力してください。</span>
                  <b-button class="is-primary" style="float:right; margin-left: 10px;" icon-right="chevron-double-right" @click.prevent="Forward" :disabled="reqParams.prescriptionItems.length==0">次へ</b-button>
                </div>
                <div class="card-content margin-top">
                  <span style="font-size:20px;">装置情報</span>
                  <table>
                    <!-- 医療機関/ディーラーユーザーは非表示20230913 -->
                    <template v-if="!isHospital || !isDealer">
                    <tr>
                      <th>機種<span class="require"/></th>
                      <td>
                        <!-- 仮持出 -->
                        <input v-if="temp" disabled style="width:80%;" type="text" v-model="reqParams.model" data-vv-as="機種" class="3" name="機種" validate="required"/>
                        <!-- 仮持出以外 -->
                        <select v-else id="model" class="3" name="機種" validate="required" @change="changeModel" v-model="reqParams.reportFormatType">
                          <option v-for="model in modelList" :value="model.reportFormatType" :key="model.reportFormatType">{{ model.itemName }}</option>
                        </select>
                      </td>
                    </tr>
                    </template>
                    <!-- 新規処方(預託在庫),処方変更申込みの場合シリアル入力する -->
                    <tr v-if="isInstrument || changePrescription">
                      <th style="white-space:pre-wrap;">シリアル<span class="require"/></th>
                      <td>
                        <input type="text" data-vv-as="CPAP機器シリアル" maxlength="18" v-model="reqParams.serial" class="3" name="シリアル" validate="required"/>
                      </td>
                    </tr>
                    <!-- 仮持出 -->
                    <tr v-if="temp">
                      <th style="white-space:pre-wrap;">シリアル<span class="require"/></th>
                      <td><input disabled style="width:80%;" type="text" maxlength="18" v-model="reqParams.serial" data-vv-as="CPAP機器シリアル" class="3" name="シリアル" validate="required"/>
                      <b-button style="margin-left:10px; width:150px; height:27px;" v-on:click="tempDeviceSelectModalActive=true">機器選択</b-button>
                      </td>
                    </tr>
                    <!--
                    <template>
                      <tr>
                        <th>使用機器</th><td><b-checkbox class="cstmCheckBox" v-model="reqParams.depositUseFlag">預託機を使用する（要預託契約）</b-checkbox></td>
                      </tr>
                    </template>
                    -->
                  </table>
                </div>
                <div class="card-content margin-top" v-if="reqParams.model">
                  <span style="font-size:20px;">設定情報</span>
                  <div style="display: flex;">
                    <form data-vv-scope="form3">
                      <table class="settings">
                        <template v-for="(content, index) in reqParams.prescriptionItems.filter(val=>{ return val.category===0})">
                          <!-- テキスト項目 -->
                          <tr v-if="content.type==='char' && (content.mode.indexOf(0)!=-1 || !reqParams.mode || content.mode.indexOf(reqParams.mode)!=-1)" :key="index">
                            <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                            <td>
                              <b-field
                              :type="{'is-danger':errors.has('form3.form3char_'+index)&&!content.disabled}"
                              :message="
                              `${errors.has('form3.form3char_'+index)&&!content.disabled ? errors.first('form3.form3char_'+index) : ''}`">
                                <input
                                  style="width:500px;"
                                  type="text"
                                  :name="'form3char_'+index"
                                  :data-vv-as="content.displayName"
                                  v-validate="`${content.required ? 'required':''}|validationCheck:${content.value},${encodeURI(content.validationRule)}`"
                                  v-model="content.value"
                                  @input="changeSelect(content.displayName,content.value)"
                                  :disabled="content.disabled"/>{{content.unit}}
                              </b-field>
                            </td>
                            <td>
                              <!-- 説明コメント用 -->
                            </td>
                          </tr>
                          <!-- セレクトボックス -->
                          <tr v-if="content.type=== 'sel' && (content.mode.indexOf(0)!=-1 || !reqParams.mode || content.mode.indexOf(reqParams.mode)!=-1)" :key="index">
                            <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                            <td>
                              <b-field
                              :type="{'is-danger':errors.has('form3.form3sel_'+index)&&!content.disabled}"
                              :message="`${errors.has('form3.form3sel_'+index)&&!content.disabled ? errors.first('form3.form3sel_'+index) : ''}`">
                                <select 
                                style="width:500px;"
                                :name="'form3.form3sel_'+index"
                                :data-vv-as="content.displayName"
                                v-model="content.value"
                                v-validate="`${content.required ? 'required':''}`"
                                @change="changeSelect(content.displayName,content.value)"
                                :disabled="content.disabled">
                                  <option
                                  v-for="tmpValue in content.displayValue"
                                  :value="tmpValue.key"
                                  :key="tmpValue.key"
                                  >{{ tmpValue.value }}</option></select>{{content.unit}}
                              </b-field>
                            </td>
                            <td>
                              <!-- 説明コメント用 -->
                            </td>
                          </tr>
                          <!-- カレンダー -->
                          <tr v-if="content.type=== 'calender' && (content.mode.indexOf(0)!=-1 || !reqParams.mode || content.mode.indexOf(reqParams.mode)!=-1)" :key="index">
                            <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                            <td>
                              <b-field
                              :type="{'is-danger':errors.has('form3.form3calender_'+index)}"
                              :message="errors.first('form3.form3calender_'+index)">
                                <input style="width:500px;" type="date" :name="'form3calender_'+index" :data-vv-as="content.displayName" v-model="content.value" v-validate="`${content.required ? 'required':''}`"/>
                              </b-field>
                            </td>
                            <td>
                              <!-- 説明コメント用 -->
                            </td>
                          </tr>
                          <!-- ラジオボタン -->
                          <tr v-if="content.type==='radio' && (content.mode.indexOf(0)!=-1 || !reqParams.mode || content.mode.indexOf(reqParams.mode)!=-1)" :key="index">
                            <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                            <td>
                              <div>
                                <b-radio
                                v-for="tmpValue in content.displayValue"
                                v-model="content.value"
                                :value="tmpValue.value"
                                :key="tmpValue.key"
                                :name="'form3radio_'+index+'_'"
                                :native-value="tmpValue.key"
                                style="text-align:left; margin-Right:10px;"
                                >{{tmpValue.value}}</b-radio>
                              </div>
                              <!-- :disabled="content.isDisabled=='true'" -->
                            </td>
                          </tr>
                          <tr v-if="content.annotation" :key="index+'α'">
                            <td style="white-space:pre-wrap;color:red;" colspan="3">{{content.annotation}}</td>
                          </tr>
                        </template>
                      </table>
                    </form>
                  </div>
                </div>
              </div>
            </b-step-item>
            <b-step-item step="4" label="関連用品" icon="clipboard-check-outline">
              <form data-vv-scope="form4">
                <div id="item-contens">
                  <div class="request-title">
                    <b-button class="is-primary" style="float:left;" icon-left="chevron-double-left" @click.prevent="Backward">前へ</b-button>
                    <span>関連用品を入力してください。</span>
                    <b-button class="is-primary" style="float:right;" icon-right="chevron-double-right" @click.prevent="Forward">次へ</b-button>
                  </div>
                  <div class="card-content margin-top">
                    <span style="font-size:20px;">加温加湿器</span>
                    <table class="settings">
                      <template v-for="(content, index) in reqParams.prescriptionItems.filter(val=>{ return val.category===1})">
                        <!-- テキスト項目 -->
                        <tr v-if="content.type==='char' && reqParams.useMoist && (content.mode.indexOf(0)!=-1 || !reqParams.mode || content.mode.indexOf(reqParams.mode)!=-1) && (content.displayName=='機種' && !isHospital && !isDealer)" :key="index">
                          <th style="white-space:pre-wrap;width:250px;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                          <td>
                            <b-field
                            :type="{'is-danger':errors.has('form4.form4char_'+index)}"
                            :message="errors.first('form4.form4char_'+index)">
                              <input style="width:500px;" type="text" :name="'form4char_'+index" :data-vv-as="content.displayName" v-validate="`${content.required ? 'required':''}|validationCheck:${content.value},${encodeURI(content.validationRule)}`" v-model="content.value"/>{{content.unit}}
                              <!-- <span v-if="errors.has('char_'+index)" style="color:red;">{{errors.first('char_'+index)}}</span> -->
                            </b-field>
                          </td>
                          <td>
                            <!-- 説明コメント用 -->
                          </td>
                        </tr>
                        <!-- セレクトボックス -->
                        <tr v-if="content.type=== 'sel' && reqParams.useMoist && (content.mode.indexOf(0)!=-1 || !reqParams.mode || content.mode.indexOf(reqParams.mode)!=-1)" :key="index">
                          <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                          <td>
                            <b-field
                            :type="{'is-danger':errors.has('form4.form4sel_'+index)}"
                            :message="errors.first('form4.form4sel_'+index)">
                              <select
                              style="width:500px;"
                              :name="'form4sel_'+index"
                              :data-vv-as="content.displayName"
                              v-model="content.value"
                              v-validate="`${content.required ? 'required':''}`"
                              @change="changeSelect(content.displayName,content.value)"
                              :disabled="content.disabled">
                                <option
                                v-for="tmpValue in content.displayValue"
                                :value="tmpValue.key"
                                :key="tmpValue.key"
                                >{{ tmpValue.value }}</option></select>{{content.unit}}
                            </b-field>
                          </td>
                          <td>
                            <!-- 説明コメント用 -->
                          </td>
                        </tr>
                        <!-- カレンダー -->
                        <tr v-if="content.type=== 'calender' && reqParams.useMoist && (content.mode.indexOf(0)!=-1 || !reqParams.mode || content.mode.indexOf(reqParams.mode)!=-1)" :key="index">
                          <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                          <td>
                            <b-field
                            :type="{'is-danger':errors.has('form4.form4calender_'+index)}"
                            :message="errors.first('form4.form4calender_'+index)">
                              <input style="width:500px;" type="date" :name="'form4calender_'+index" :data-vv-as="content.displayName" v-model="content.value" v-validate="`${content.required ? 'required':''}`"/>
                            </b-field>
                          </td>
                          <td>
                            <!-- 説明コメント用 -->
                          </td>
                        </tr>
                        <!-- ラジオボタン -->
                        <tr v-if="content.type==='radio' && (content.mode.indexOf(0)!=-1 || !reqParams.mode || content.mode.indexOf(reqParams.mode)!=-1)" :key="index">
                          <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                          <td>
                            <div>
                              <b-radio
                              v-for="tmpValue in content.displayValue"
                              v-model="content.value"
                              :value="tmpValue.value"
                              :key="tmpValue.key"
                              :name="'form4radio1_'+index"
                              :native-value="tmpValue.key"
                              style="text-align:left; margin-Right:10px;"
                              @click.native="inputRadioValue(tmpValue.key,'useMoist')"
                              >{{tmpValue.value}}</b-radio>
                            </div>
                            <!-- :disabled="content.isDisabled=='true'" -->
                          </td>
                        </tr>
                      </template>
                      <!-- 預託在庫から申込みの場合シリアル入力する -->
                      <tr v-if="isInstrument && reqParams.useMoist">
                        <th style="white-space:pre-wrap;">シリアル<span class="require"/></th>
                        <td>
                          <input style="width:500px;" type="text" data-vv-as="加湿器シリアル" maxlength="20" v-model="reqParams.moistSerial" class="4" name="加湿器シリアル" validate="required"/>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div class="card-content margin-top">
                    <span style="font-size:20px;">通信モジュール</span>
                    <table class="settings">
                      <template v-for="(content, index) in reqParams.prescriptionItems.filter(val=>{ return val.category===2})">
                        <!-- テキスト項目 -->
                        <tr v-if="content.type==='char' && reqParams.useModule && !isHideItem(content.displayName) && (content.mode.indexOf(0)!=-1 || !reqParams.mode || content.mode.indexOf(reqParams.mode)!=-1) && ((content.displayName=='機種' && !isHospital && !isDealer) || content.displayName=='E-mailアドレス')" :key="index">
                          <th style="white-space:pre-wrap;width:250px;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                          <td>
                            <b-field
                            :type="{'is-danger':errors.has('form4.form4_2char_'+index)}"
                            :message="errors.first('form4.form4_2char_'+index)">
                              <input style="width:500px;" type="text" :name="'form4_2char_'+index" :data-vv-as="content.displayName" v-validate="`${content.required ? 'required':''}|validationCheck:${content.value},${encodeURI(content.validationRule)}`" v-model="content.value"/>{{content.unit}}
                            </b-field>
                          </td>
                          <td>
                            <!-- 説明コメント用 -->
                          </td>
                        </tr>
                        <!-- セレクトボックス -->
                        <tr v-if="content.type=== 'sel' && reqParams.useModule && !isHideItem(content.displayName) && (content.mode.indexOf(0)!=-1 || !reqParams.mode || content.mode.indexOf(reqParams.mode)!=-1)" :key="index">
                          <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                          <td>
                            <b-field
                            :type="{'is-danger':errors.has('form4.form4_2sel_'+index)}"
                            :message="errors.first('form4.form4_2sel_'+index)">
                              <select style="width:500px;" :name="'form4_2sel_'+index" :data-vv-as="content.displayName" v-model="content.value" v-validate="`${content.required ? 'required':''}`">
                                <option
                                v-for="tmpValue in content.displayValue"
                                :value="tmpValue.key"
                                :key="tmpValue.key"
                                >{{ tmpValue.value }}</option></select>{{content.unit}}
                            </b-field>
                          </td>
                          <td>
                            <!-- 説明コメント用 -->
                          </td>
                        </tr>
                        <!-- カレンダー -->
                        <tr v-if="content.type=== 'calender' && reqParams.useModule && (content.mode.indexOf(0)!=-1 || !reqParams.mode || content.mode.indexOf(reqParams.mode)!=-1)" :key="index">
                          <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                          <td>
                            <b-field
                            :type="{'is-danger':errors.has('form4.form4_2calender_'+index)}"
                            :message="errors.first('form4.form4_2calender_'+index)">
                              <input style="width:500px;" type="date" :name="'form4_2calender_'+index" :data-vv-as="content.displayName" v-model="content.value" v-validate="`${content.required ? 'required':''}`"/>
                            </b-field>
                          </td>
                          <td>
                            <!-- 説明コメント用 -->
                          </td>
                        </tr>
                        <!-- ラジオボタン -->
                        <tr v-if="content.type==='radio' && (content.mode.indexOf(0)!=-1 || !reqParams.mode || content.mode.indexOf(reqParams.mode)!=-1)" :key="index">
                          <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                          <td>
                            <div>
                              <b-radio
                              v-for="tmpValue in content.displayValue"
                              v-model="content.value"
                              :value="tmpValue.value"
                              :key="tmpValue.key"
                              :name="'form4_2radio2_'+index"
                              :native-value="tmpValue.key"
                              :disabled="reqParams.reportFormatType==6"
                              style="text-align:left; margin-Right:10px;"
                              @click.native="inputRadioValue(tmpValue.key,'useModule')"
                              >{{tmpValue.value}}</b-radio>
                            </div>
                            <!-- :disabled="content.isDisabled=='true'" -->
                          </td>
                        </tr>
                      </template>
                      <!-- 通信モジュールリストボックス -->
                      <tr v-if="!temp && reqParams.useModule && (reqParams.moduleItemCode || moduleList) && !isHospital && !isDealer">
                        <th style="white-space:pre-wrap;">機種<span class="require"/></th>
                        <td v-if="moduleList">
                          <select style="width:500px;" id="moduleItemCode" class="4" name="通信モジュール機種" validate="required" v-model="reqParams.moduleItemCode">
                            <option v-for="val in moduleList" :value="val.itemCode" :key="val.itemCode">{{ val.itemName }}</option>
                          </select>
                        </td>
                        <td v-else>
                          <input style="width:500px;" type="text" disabled data-vv-as="通信モジュール品目コード" maxlength="20" v-model="reqParams.moduleItemCode"/>
                        </td>
                      </tr>
                      <!-- 預託在庫から申込みの場合シリアル入力する -->
                      <!-- <tr v-if="isInstrument && reqParams.useModule"> -->
                      <tr v-if="isInstrument && reqParams.useModule && this.reqParams.model !='RJPG500S16'">
                        <th style="white-space:pre-wrap;">シリアル<span class="require"/></th>
                        <td>
                          <input style="width:500px;" type="text" data-vv-as="通信モジュールシリアル" maxlength="20" v-model="reqParams.moduleSerial" class="4" name="通信モジュールシリアル" validate="required"/>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div class="card-content margin-top">
                    <span style="font-size:20px;">マスク</span>
                    <table class="settings">
                      <tr>
                        <th style="white-space:pre-wrap;width:250px;">マスク：種類<span class="require"/></th>
                        <td>
                          <input disabled style="width:500px;" type="text" class="4" name="マスク種類" validate="required" v-model="reqParams.maskType"/>
                          <b-button type="is-primary" style="margin-left:10px; width:150px; height:27px;" v-on:click="getMaskMaster()">マスク選択</b-button>
                        </td>
                        <td>
                        </td>
                      </tr>
                      <tr>
                        <th style="white-space:pre-wrap;width:250px;">マスク：クッションサイズ<span class="require"/></th>
                        <td>
                          <input disabled style="width:500px;" type="text" class="4" name="クッションサイズ" validate="required" v-model="reqParams.cushionSize"/>
                        </td>
                        <td></td>
                      </tr>
                      <tr>
                        <th style="white-space:pre-wrap;width:250px;">マスク：フレームサイズ<span class="require"/></th>
                        <td>
                          <input disabled style="width:500px;" type="text" class="4" name="フレームサイズ" validate="required" v-model="reqParams.frameSize"/>
                        </td>
                        <td></td>
                      </tr>
                      <tr>
                        <th style="white-space:pre-wrap;width:250px;">マスク：固定方法<span class="require"/></th>
                        <td>
                          <input disabled style="width:500px;" type="text" class="4" name="固定方法" validate="required" v-model="reqParams.fixingMethod"/>
                        </td>
                        <td></td>
                      </tr>
                      <tr v-if="reqParams.maskType=='その他'">
                        <th style="white-space:pre-wrap;width:250px;">備考</th>
                        <td>
                          <textarea maxlength="256" style="resize:vertical;width:500px;max-width:500px;height:120px" v-model="reqParams.memo"></textarea>                          
                        </td>
                        <td></td>
                      </tr>
                    </table>
                  </div>
                </div>
              </form>
            </b-step-item>
            <b-step-item step="5" label="納品先情報" icon="clipboard-check-outline" v-if="!temp && !isInstrument && !resume">
              <form data-vv-scope="form5">
                <div id="item-contens">
                  <div class="request-title">
                    <b-button class="is-primary" style="float:left;" icon-left="chevron-double-left" @click.prevent="Backward">前へ</b-button>
                    <span>納品先を入力してください。</span>
                    <b-button class="is-primary" style="float:right;" icon-right="chevron-double-right" @click.prevent="Forward">次へ</b-button>
                  </div>
                  <div class="card-content margin-top">
                    <span style="font-size:20px;">納品先情報</span>
                    <table>
                      <tr><th>機器納品先<span class="require"/></th><td>
                        <div class="block">
                          <b-radio class="td_radio" name="target"  v-model="reqParams.delivaryTarget" native-value="home">患者宅</b-radio>
                          <b-radio class="td_radio" name="target"  v-model="reqParams.delivaryTarget" native-value="hospital">医療機関</b-radio>
                        </div></td>
                      </tr>
                      <template v-if="reqParams.delivaryTarget== 'hospital'">
                        <tr>
                          <th>
                            郵便番号<span class="require"/>
                          </th>
                          <td>
                            <input
                              style="width: 270px;"
                              v-model="reqParams.zip"
                              class="5"
                              :class="{'border-red': invalidDeliveryPostcode}"
                              name="機器納品先の郵便番号"
                              validate="required|numeric"
                              maxlength="7"
                              :placeholder="postcodePlaceholder"/>
                            <b-button
                              style="margin-left: 10px; width: 150px; height: 27px;"
                              v-on:click="addressSearch('device',reqParams.zip)"
                            >
                              郵便番号検索
                            </b-button>
                            <div v-show="invalidDeliveryPostcode" class="text-red">{{ invalidNumberMessage }}</div>
                          </td>
                        </tr>
                        <tr><th>住所<span class="require"/></th><td><input type="text" v-model="reqParams.address" class="5" name="機器納品先の住所" validate="required" maxlength="280"/></td></tr>
                        <tr><th>住所（丁目、番地）<span class="require"/></th><td><input type="text" v-model="reqParams.address1" class="5" name="機器納品先の住所（丁目、番地）" validate="required" maxlength="256"/></td></tr>
                        <tr><th>住所（建物名、号室）</th><td><input type="text" v-model="reqParams.address2" maxlength="256"/></td></tr>
                        <tr><th>納品先宛名<span class="require"/></th><td><input type="text" v-model="reqParams.receiverName" maxlength="100" class="5" name="納品先宛名" validate="required"/></td></tr>
                        <tr>
                          <th>
                            連絡先(電話番号)<span class="require"/>
                          </th>
                          <td>
                            <input
                              type="text"
                              v-model="reqParams.phoneNumber"
                              maxlength="11"
                              class="5"
                              :class="{'border-red': invalidDeliveryPhoneNumber}"
                              name="機器納品先の連絡先(電話番号)"
                              validate="required|numeric"
                              :placeholder="phonePlaceholder"
                            />
                            <div v-show="invalidDeliveryPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
                          </td>
                        </tr>
                      </template>
                    </table>
                  </div>
                </div>
              </form>
            </b-step-item>
            <b-step-item step="6" label="申込み" icon="cloud-upload">
              <div id="item-contens">
                <div class="request-title">
                  <b-button class="is-primary" style="float:left;" icon-left="chevron-double-left" @click.prevent="Backward" >前へ</b-button>
                  <span>以下の申込み内容を確認のうえ、下部の「申込みを完了する」ボタンを押下してください。</span>
                </div>
                <!--　申込み詳細 -->
                <cpapRequestDetail :data="reqParams" :showRequestMemo="false" v-bind:key="renderKey" :deliveryHidden="temp||isInstrument" :requestFlg="true" :isinstrument="isInstrument" :resume="resume"/>
                <div class="card-content margin-top">
                  <span style="font-size:20px;">その他</span>
                  <table>
                    <tr>
                      <th style="vertical-align:top;">備考</th>
                      <td>
                        <textarea maxlength="256" style="resize:vertical;max-width:100%;height:120px" v-model="reqParams.memo"></textarea>
                      </td>
                    </tr>
                    <tr><th></th><td><span style="font-size: 14px;">※伝達事項がございましたらご記入ください。</span></td></tr>
                  </table>
                </div>
                <b-button v-if="isHospitalNewOrder()" class="is-primary" style="margin-top:5px;width:250px;" @click="saveCpapRequestDraft">申込み内容を保存する</b-button>
                <b-button class="is-primary" style="margin-top:5px;width:250px;" @click="requestCpap">申込みを完了する</b-button>
              </div>
            </b-step-item>
            <b-step-item step="7" label="完了" icon="check" :type="{'is-success': true}">
              <section class="unPrintTarget">
                <div class="request-title"><span>処方申込みを受け付けました。</span></div>
                <div class="request-title" v-if="needAgree"><span style="color:red;">Philipsにて受付を実施いたします。受付完了しましたらメールにてご連絡いたします。</span></div>
                <div class="margin-top">
                  <b-button class="backbutton is-primary" @click="back">戻る</b-button>
                  <b-button class="printbutton is-primary" icon-left="printer" @click="print">印刷</b-button>
                </div>
              </section>
              <section class="printTarget">
                <cpapRequestDetail :data="reqParams" :showRequestInfo="true" v-bind:key="renderKey" :deliveryHidden="temp||isInstrument" :requestFlg="true" :isinstrument="isInstrument" :resume="resume"/>
              </section>
            </b-step-item>
          </b-steps>
        </div>
        </form>
      </div>
    </section>
    <b-modal :active.sync="organizationModalActive" has-modal-card>
      <organizationSelectModal v-if="isSalesOffice || isHonsha || isAdmin" :selectRole="[role.role_hospital]" :selectStatus="extUserStatus.registed" title="医療機関選択" labelForOrg="医療機関名" @select="setOrganization"></organizationSelectModal>
      <facilitySelectModal v-if="isDealer" :dealerId="userId" @select="setfacility"></facilitySelectModal>
    </b-modal>
    <b-modal :active.sync="maskSelectModalActive" has-modal-card full-screen>
      <cpapMaskSelectModal :formatType="formatType" @select="maskSelect"></cpapMaskSelectModal>
    </b-modal>
    <b-modal :active.sync="tempDeviceSelectModalActive" has-modal-card>
      <instrumentSelectModal @select="tempDeviceSelect" :selectModel="reqParams.model" :selectSerial="reqParams.serial" :searchType="0" :belongsId="reqParams.belongsId"></instrumentSelectModal>
    </b-modal>
  </div>
</template>
<script>
import {
  role,
  consentStatement,
  choicesType,
  extUserStatus,
  LendingPeriod,
  cpapRequestStatus,
  cpapKindMap,
  invalidNumberMessage,
  postcodePlaceholder,
  phonePlaceholder,
  prescriptionHardwareList,
} from "@/components/mock/base/const.js";
import OrganizationSelectModal from "@/components/mock/philips/common/OrganizationSelectModal";
import CpapMaskSelectModal from "@/components/mock/philips/common/CpapMaskSelectModal";
import FacilitySelectModal from "@/components/mock/philips/common/FacilitySelectModal";
import InstrumentSelectModal from "@/components/mock/philips/common/InstrumentSelectModal";
import OfficeCalenderModal from "@/components/mock/guest/OfficeCalenderModal";
import CpapRequestDetail from "@/components/mock/common/CpapRequestDetail";

export default {
  name: "CpapRequest",
  methods: {
    Backward: function() {
      this.activeStep -= 1;
    },
    Forward: async function(event) {
      // バリデーションチェック
      var stepItems = document.getElementsByClassName("step-item")
      var target
      for(var item of stepItems){
        if(item.getAttribute("style") != "display: none;"){
          target = item
        }
      }
      var activeStep = target ? target.getAttribute("step") : ""
      if(activeStep){
        const validateResult = await this.$validator.validateAll("form"+activeStep);
        if (!validateResult && !this.reqParams.existingFlag) {
          this.showErrorMessage("入力内容に誤りがあります。")
          return
        }

        // 移行データはバリデーション制御を入れない
        if (!this.reqParams.existingFlag) {
        var elements = document.getElementsByClassName(activeStep)
        var result = this.selfMadeValidation(elements)

        if(activeStep==2){
          var phoneNumber = document.getElementById("phoneNumber")
          var mobilePhone = document.getElementById("mobilePhone")
          phoneNumber.style["border-color"] = "";
          mobilePhone.style["border-color"] = "";
          if(!this.reqParams.patient.phoneNumber && !this.reqParams.patient.mobilePhone){
            // 患者の連絡先がいずれも未入力の場合
            result.isError = true
            result.msg = result.msg + "「連絡先（携帯電話）」「連絡（自宅・その他）」いずれかは必須項目です。\n"
            phoneNumber.style["border-color"] = "red";
            mobilePhone.style["border-color"] = "red";
          }
        }else if(activeStep==3){
          var model = this.modelList.find(val => val.itemCodes && val.itemCodes.indexOf(this.reqParams.model) != -1)
          // 相関チェック
          var errMsg = ""
          switch(model.reportFormatType){
            case 1:
              // ドリームステーションAuto
              var lampStart = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
              if(this.reqParams.mode == "1"){
                var pressureMin = this.reqParams.prescriptionItems.find(val => val.displayName == "最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                var pressureMax = this.reqParams.prescriptionItems.find(val => val.displayName == "最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                if(Number(pressureMin.value) > Number(pressureMax.value)){
                  // "最小圧【hPa(cmH2O)】" <= "最大圧【hPa(cmH2O)】" でない時
                  errMsg = errMsg + "「最小圧」に「最大圧」以下の値を設定してください。\n"
                }
                if(Number(lampStart.value) > Number(pressureMin.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "最小圧【hPa(cmH2O)】" でない時
                  errMsg = errMsg + "「ランプスタート圧」に「最小圧」以下の値を設定してください。\n"
                }
              }else{
                var pressureCpap = this.reqParams.prescriptionItems.find(val => val.displayName == "CPAP圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                if(Number(lampStart.value) > Number(pressureCpap.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
                  errMsg = errMsg + "「ランプスタート圧」に「CPAP圧」以下の値を設定してください。\n"
                }
              }
              break;
            case 2:
              // ドリームステーションPro
              var lampStart = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
              var pressureCpap = this.reqParams.prescriptionItems.find(val => val.displayName == "CPAP圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
              if(Number(lampStart.value) > Number(pressureCpap.value)){
                // "ランプスタート圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
                errMsg = errMsg + "「ランプスタート圧」に「CPAP圧」以下の値を設定してください。\n"
              }
              break;
            case 3:
              // ドリームステーションGo
              var lampStart = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
              if(this.reqParams.mode == "1"){
                var pressureMax = this.reqParams.prescriptionItems.find(val => val.displayName == "最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                var pressureMin = this.reqParams.prescriptionItems.find(val => val.displayName == "最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                if(Number(pressureMin.value) > Number(pressureMax.value)){
                  // "最小圧【hPa(cmH2O)】" <= "最大圧【hPa(cmH2O)】" でない時
                  errMsg = errMsg + "「最小圧」に「最大圧」以下の値を設定してください。\n"
                }
                if(Number(lampStart.value) > Number(pressureMin.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "最小圧【hPa(cmH2O)】" でない時
                  errMsg = errMsg + "「ランプスタート圧」に「最小圧」以下の値を設定してください。\n"
                }
              }else{
                var pressureCpap = this.reqParams.prescriptionItems.find(val => val.displayName == "CPAP圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                if(Number(lampStart.value) > Number(pressureCpap.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
                  errMsg = errMsg + "「ランプスタート圧」に「CPAP圧」以下の値を設定してください。\n"
                }
              }
              break;
            case 4:
              // ドリームステーションBiPAP Auto
              var lampStart = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
              if(this.reqParams.mode == "4"){
                // CPAPモード
                var pressureCpap = this.reqParams.prescriptionItems.find(val => val.displayName == "CPAP圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                if(Number(lampStart.value) > Number(pressureCpap.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
                  errMsg = errMsg + "「ランプスタート圧」に「CPAP圧」以下の値を設定してください。\n"
                }
              }else if(this.reqParams.mode == "8"){
                // Bi-Levelモード
                var epap = this.reqParams.prescriptionItems.find(val => val.displayName == "EPAP【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                var ipap = this.reqParams.prescriptionItems.find(val => val.displayName == "IPAP【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                if(Number(epap.value) > Number(ipap.value)){
                  // "EPAP【hPa(cmH2O)】" <= "IPAP【hPa(cmH2O)】" で無い時
                  errMsg = errMsg + "「EPAP」に「IPAP」以下の値を設定してください。\n"
                }
                if(Number(lampStart.value) > Number(epap.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "EPAP【hPa(cmH2O)】" でない時
                  errMsg = errMsg + "「ランプスタート圧」に「EPAP」以下の値を設定してください。\n"
                }
                var flex = this.reqParams.prescriptionItems.find(val => val.displayName == "Flexタイプ" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                if(flex=="1"){
                  // Bi-Flex
                  if(Number(epap.value) == Number(ipap.value)){
                    // 「IPAPの値≠EPAPの値」でない場合
                    errMsg = errMsg + "「EPAP」「IPAP」に異なる値を設定してください。\n"
                  }
                }else if(flex=="2" || flex=="3"){
                  // C-Flex
                  // C-Flex+
                  if(Number(epap.value) != Number(ipap.value)){
                    // 「IPAPの値=EPAPの値」でない場合
                    errMsg = errMsg + "「EPAP」「IPAP」に同じ値を設定してください。\n"
                  }
                }
              }else if(this.reqParams.mode == "1"){
                // Auto Bi-Levelモード
                var epapMin = this.reqParams.prescriptionItems.find(val => val.displayName == "EPAP最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                var ipapMax = this.reqParams.prescriptionItems.find(val => val.displayName == "IPAP最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                if(Number(epapMin.value) > Number(ipapMax.value)){
                  // "EPAP最小圧【hPa(cmH2O)】" <= "IPAP最大圧【hPa(cmH2O)】" で無い時
                  errMsg = errMsg + "「EPAP最小圧」に「IPAP最大圧」以下の値を設定してください。\n"
                }
                var psMin = this.reqParams.prescriptionItems.find(val => val.displayName == "PS最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                var psMax = this.reqParams.prescriptionItems.find(val => val.displayName == "PS最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                if(Number(psMin.value) > Number(psMax.value)){
                  // "PS最小圧【hPa(cmH2O)】" <= "PS最大圧【hPa(cmH2O)】" で無い時
                  errMsg = errMsg + "「PS最小圧」に「PS最大圧」以下の値を設定してください。\n"
                }
                if(Number(lampStart.value) > Number(epapMin.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "EPAP最小圧【hPa(cmH2O)】" でない時
                  errMsg = errMsg + "「ランプスタート圧」に「EPAP最小圧」以下の値を設定してください。\n"
                }
                var flex = this.reqParams.prescriptionItems.find(val => val.displayName == "Flexタイプ" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                if(flex=="1"){
                  // Bi-Flex
                  if(Number(psMin.value)==0 && Number(psMax.value)==0){
                    // 「PS最小圧≠0 または PS最大圧≠0 」でない場合
                    errMsg = errMsg + "「PS最小圧」または「PS最大圧」に0以外の値を設定してください。\n"
                  }
                }else if(flex=="2"){
                  // C-Flex
                  if(Number(psMin.value)!=0 || Number(psMax.value)!=0){
                    // 「PS最小圧=0」且つ「PS最大圧=0」でない場合
                    errMsg = errMsg + "「PS最小圧」「PS最大圧」に0を設定してください。\n"
                  }
                }
              }
              break;
            case 5:
              // エスボックス バイスタルク
              var lampStart = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプ開始圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
              if(this.reqParams.mode == "4"){
                // CPAPモード
                // "ランプ開始圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
              }else if(this.reqParams.mode == "1"){
                // Auto CPAPモード
                var pressureMax = this.reqParams.prescriptionItems.find(val => val.displayName == "最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                var pressureMin = this.reqParams.prescriptionItems.find(val => val.displayName == "最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                if(Number(pressureMin.value) > Number(pressureMax.value)){
                  // "最小圧【hPa(cmH2O)】" <= "最大圧【hPa(cmH2O)】" でない時
                  errMsg = errMsg + "「最小圧」に「最大圧」以下の値を設定してください。\n"
                }
                if(Number(lampStart.value) > Number(pressureMin.value)){
                  // "ランプ開始圧【hPa(cmH2O)】" <= "最小圧【hPa(cmH2O)】" でない時
                  errMsg = errMsg + "「ランプ開始圧」に「最小圧」以下の値を設定してください。\n"
                }
              }
              break;
            case 6:
              // プリズマ ライン (prisma25S)
              if(this.reqParams.mode == "1"){
                // APAPモード
                var pressureMax = this.reqParams.prescriptionItems.find(val => val.displayName == "最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                var pressureMin = this.reqParams.prescriptionItems.find(val => val.displayName == "最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                if(Number(pressureMin.value) > Number(pressureMax.value)){
                  // "最小圧【hPa(cmH2O)】" <= "最大圧【hPa(cmH2O)】" でない時
                  errMsg = errMsg + "「最小圧」に「最大圧」以下の値を設定してください。\n"
                }
              }else if(this.reqParams.mode == "7"){
                // Sモード
                var epap = this.reqParams.prescriptionItems.find(val => val.displayName == "EPAP圧【hPa（cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                var ipap = this.reqParams.prescriptionItems.find(val => val.displayName == "IPAP圧【hPa（cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                if(Number(epap.value) > Number(ipap.value)){
                  // "EPAP【hPa(cmH2O)】" <= "IPAP【hPa(cmH2O)】" で無い時
                  errMsg = errMsg + "「EPAP」に「IPAP」以下の値を設定してください。\n"
                }
              }else if(this.reqParams.mode == "9"){
                // autoSモード
                var pdiffMin = this.reqParams.prescriptionItems.find(val => val.displayName == "PDIFF min 圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                var pdiffMax = this.reqParams.prescriptionItems.find(val => val.displayName == "PDIFF max 圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                if(Number(pdiffMin.value) > Number(pdiffMax.value)){
                  // "PDIFF min 圧【hPa(cmH2O)】" <= "PDIFF max 圧【hPa(cmH2O)】" で無い時
                  errMsg = errMsg + "「PDIFF min 圧」に「PDIFF max 圧」以下の値を設定してください。\n"
                }
              }
              break;
          }
          if(errMsg){
            // 相関チェックエラーの場合
            this.showErrorMessage(errMsg)
            return
          }
        }
        if(result.isError){
          this.showErrorMessage(result.msg)
        }else{
          // 再レンダリングの為、フラグ切替
          this.renderKey = !this.renderKey
          this.activeStep += 1;
        }
                } else {
          if (this.reqParams.resume && activeStep == 2) {
            // 移行データの転院再開時「医師名」「診察券ID」はバリデーションをかける
            var elements = document.getElementsByClassName("resumeExisting")
            var result = this.selfMadeValidation(elements)
            result.isError = false
            result.msg = ""
            var doctorName = document.getElementById("doctorName")
            if (!this.reqParams.doctorName) {
              // 「医師名」が未入力の場合
              result.isError = true
              result.msg = result.msg + "「医師名」は必須項目です。\n"
              doctorName.style["border-color"] = "red";
            }
            var patientRegistrationCard = document.getElementById("patientRegistrationCard")
            if (!this.reqParams.patient.patientRegistrationCard) {
              // 「診察券ID」が未入力の場合
              result.isError = true
              result.msg = result.msg + "「診察券ID（患者ID）」は必須項目です。\n"
              patientRegistrationCard.style["border-color"] = "red";
            }
            if(result.isError){
              this.showErrorMessage(result.msg)
            } else {
              // 再レンダリングの為、フラグ切替
              this.renderKey = !this.renderKey
              this.activeStep += 1;
            }
          } else {
            // 再レンダリングの為、フラグ切替
            this.renderKey = !this.renderKey
            this.activeStep += 1;
          }
        }
      }
    },
    isHideItem: function(displayName) {
      if(displayName == "登録方法"){
        var patientManagement = this.reqParams.prescriptionItems.find(val => val.displayName == "患者情報管理")
        if(patientManagement && patientManagement.value=='0'){
          return true
        }
      }
      if(displayName == "E-mailアドレス"){
        var mobileApply = this.reqParams.prescriptionItems.find(val => val.displayName == "モバイルアプリ")
        if(mobileApply && mobileApply.value=='0'){
          return true
        }
      }
      return false
    },
    isHospitalNewOrder() {
      return this.isHospital && !this.temp && !this.isInstrument && this.reqParams.kind == cpapKindMap.application;
    },
    saveCpapRequestDraft() {
      const THIS = this;
      this.$dialog.confirm({
        title: "　",
        message: "申込み内容を保存して入力操作を終了します。",
        cancelText: "キャンセル",
        confirmText: "OK",
        onConfirm: THIS.executeSaveCpapRequestDraft,
      });
    },
    executeSaveCpapRequestDraft() {
      const THIS = this;
      var body = {
        tempReceptionNo: this.reqParams.tempReceptionNo,
        belongsId: this.belongsId,
        institutionId: this.institutionId,
        applicationType: this.reqParams.kind,
        medicalInstitutionName: this.reqParams.medicalInstitutionName,
        doctorName: this.reqParams.doctorName,
        clerkName: this.reqParams.clerkName,
        patientCardId: this.reqParams.patient.patientRegistrationCard,
        patientLastName: this.reqParams.patient.patientFamilyName,
        patientFirstName: this.reqParams.patient.patientFirstName,
        patientLastNameKana: this.reqParams.patient.patientFamilyNameKana,
        patientFirstNameKana: this.reqParams.patient.patientFirstNameKana,
        patientGender: this.reqParams.patient.gender,
        patientBirthday: this.reqParams.patient.birthday,
        patientReceiverName: this.reqParams.patient.receiverName,
        patientPostCode: this.reqParams.patient.zip,
        patientAddress: this.reqParams.patient.address,
        patientAddressHouseNumber: this.reqParams.patient.address1,
        patientAddressBuildingName: this.reqParams.patient.address2,
        patientMobilePhoneNumber: this.reqParams.patient.mobilePhone,
        patientOtherPhoneNumber: this.reqParams.patient.phoneNumber,
        isEnabledFollowUpCall: this.reqParams.patient.followUpCall,
        diseaseName: this.reqParams.patient.disease,
        infectionType: this.reqParams.patient.infection,
        infectionName: this.reqParams.patient.infectionName,
        regionalInstitutionName: this.reqParams.patient.hospitalName,
        regionalDoctorName: this.reqParams.patient.doctorName,
        deviceFormatType: this.reqParams.reportFormatType,
        deviceSettingInfo: this.reqParams.prescriptionItems,
        maskId: this.reqParams.maskId,
        destType: this.convertDestType(this.reqParams.delivaryTarget, true),
        destPostCode: this.reqParams.zip,
        destAddress: this.reqParams.address,
        destAddressHouseNumber: this.reqParams.address1,
        destAddressBuildingName: this.reqParams.address2,
        destReceiverName: this.reqParams.receiverName,
        destPhoneNumber: this.reqParams.phoneNumber,
        remarks: this.reqParams.memo,
      };
      this.apiCall(
        (client) => {
          return client.apis.externalCpap.saveCpapRequestDraft({
            body: body,
          });
        },
        (result) => {
          THIS.showSuccess(result, THIS.goHome);
        },
        (error) => {
          THIS.showErrorMessage(error);
        }
      );
    },
    convertDestType(value, isGetKey) {
      const DEST_TYPE_MAP = {
        1: "home",
        2: "hospital"
      }
      if(isGetKey) {
        return Object.keys(DEST_TYPE_MAP).find((key) => DEST_TYPE_MAP[key] == value);
      } else {
        return DEST_TYPE_MAP[value];
      }
    },
    requestCpap: function() {
      var model = this.modelList.find(val => val.itemCodes && val.itemCodes.indexOf(this.reqParams.model) != -1)
      // 相関チェック
      var errMsg = ""
      switch(model.reportFormatType){
        case 1:
          // ドリームステーションAuto
          var lampStart = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
          if(this.reqParams.mode == "1"){
            var pressureMin = this.reqParams.prescriptionItems.find(val => val.displayName == "最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            var pressureMax = this.reqParams.prescriptionItems.find(val => val.displayName == "最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(Number(pressureMin.value) > Number(pressureMax.value)){
              // "最小圧【hPa(cmH2O)】" <= "最大圧【hPa(cmH2O)】" でない時
              errMsg = errMsg + "「最小圧」に「最大圧」以下の値を設定してください。\n"
            }
            if(Number(lampStart.value) > Number(pressureMin.value)){
              // "ランプスタート圧【hPa(cmH2O)】" <= "最小圧【hPa(cmH2O)】" でない時
              errMsg = errMsg + "「ランプスタート圧」に「最小圧」以下の値を設定してください。\n"
            }
          }else{
            var pressureCpap = this.reqParams.prescriptionItems.find(val => val.displayName == "CPAP圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(Number(lampStart.value) > Number(pressureCpap.value)){
              // "ランプスタート圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
              errMsg = errMsg + "「ランプスタート圧」に「CPAP圧」以下の値を設定してください。\n"
            }
          }
          break;
        case 2:
          // ドリームステーションPro
          var lampStart = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
          var pressureCpap = this.reqParams.prescriptionItems.find(val => val.displayName == "CPAP圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
          if(Number(lampStart.value) > Number(pressureCpap.value)){
            // "ランプスタート圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
            errMsg = errMsg + "「ランプスタート圧」に「CPAP圧」以下の値を設定してください。\n"
          }
          break;
        case 3:
          // ドリームステーションGo
          var lampStart = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
          if(this.reqParams.mode == "1"){
            var pressureMax = this.reqParams.prescriptionItems.find(val => val.displayName == "最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            var pressureMin = this.reqParams.prescriptionItems.find(val => val.displayName == "最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(Number(pressureMin.value) > Number(pressureMax.value)){
              // "最小圧【hPa(cmH2O)】" <= "最大圧【hPa(cmH2O)】" でない時
              errMsg = errMsg + "「最小圧」に「最大圧」以下の値を設定してください。\n"
            }
            if(Number(lampStart.value) > Number(pressureMin.value)){
              // "ランプスタート圧【hPa(cmH2O)】" <= "最小圧【hPa(cmH2O)】" でない時
              errMsg = errMsg + "「ランプスタート圧」に「最小圧」以下の値を設定してください。\n"
            }
          }else{
            var pressureCpap = this.reqParams.prescriptionItems.find(val => val.displayName == "CPAP圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(Number(lampStart.value) > Number(pressureCpap.value)){
              // "ランプスタート圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
              errMsg = errMsg + "「ランプスタート圧」に「CPAP圧」以下の値を設定してください。\n"
            }
          }
          break;
        case 4:
          // ドリームステーションBiPAP Auto
          var lampStart = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
          if(this.reqParams.mode == "4"){
            // CPAPモード
            var pressureCpap = this.reqParams.prescriptionItems.find(val => val.displayName == "CPAP圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(Number(lampStart.value) > Number(pressureCpap.value)){
              // "ランプスタート圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
              errMsg = errMsg + "「ランプスタート圧」に「CPAP圧」以下の値を設定してください。\n"
            }
          }else if(this.reqParams.mode == "8"){
            // Bi-Levelモード
            var epap = this.reqParams.prescriptionItems.find(val => val.displayName == "EPAP【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            var ipap = this.reqParams.prescriptionItems.find(val => val.displayName == "IPAP【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(Number(epap.value) > Number(ipap.value)){
              // "EPAP【hPa(cmH2O)】" <= "IPAP【hPa(cmH2O)】" で無い時
              errMsg = errMsg + "「EPAP」に「IPAP」以下の値を設定してください。\n"
            }
            if(Number(lampStart.value) > Number(epap.value)){
              // "ランプスタート圧【hPa(cmH2O)】" <= "EPAP【hPa(cmH2O)】" でない時
              errMsg = errMsg + "「ランプスタート圧」に「EPAP」以下の値を設定してください。\n"
            }
            var flex = this.reqParams.prescriptionItems.find(val => val.displayName == "Flexタイプ" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(flex=="1"){
              // Bi-Flex
              if(Number(epap.value) == Number(ipap.value)){
                // 「IPAPの値≠EPAPの値」でない場合
                errMsg = errMsg + "「EPAP」「IPAP」に異なる値を設定してください。\n"
              }
            }else if(flex=="2" || flex=="3"){
              // C-Flex
              // C-Flex+
              if(Number(epap.value) != Number(ipap.value)){
                // 「IPAPの値=EPAPの値」でない場合
                errMsg = errMsg + "「EPAP」「IPAP」に同じ値を設定してください。\n"
              }
            }
          }else if(this.reqParams.mode == "1"){
            // Auto Bi-Levelモード
            var epapMin = this.reqParams.prescriptionItems.find(val => val.displayName == "EPAP最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            var ipapMax = this.reqParams.prescriptionItems.find(val => val.displayName == "IPAP最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(Number(epapMin.value) > Number(ipapMax.value)){
              // "EPAP最小圧【hPa(cmH2O)】" <= "IPAP最大圧【hPa(cmH2O)】" で無い時
              errMsg = errMsg + "「EPAP最小圧」に「IPAP最大圧」以下の値を設定してください。\n"
            }
            var psMin = this.reqParams.prescriptionItems.find(val => val.displayName == "PS最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            var psMax = this.reqParams.prescriptionItems.find(val => val.displayName == "PS最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(Number(psMin.value) > Number(psMax.value)){
              // "PS最小圧【hPa(cmH2O)】" <= "PS最大圧【hPa(cmH2O)】" で無い時
              errMsg = errMsg + "「PS最小圧」に「PS最大圧」以下の値を設定してください。\n"
            }
            if(Number(lampStart.value) > Number(epapMin.value)){
              // "ランプスタート圧【hPa(cmH2O)】" <= "EPAP最小圧【hPa(cmH2O)】" でない時
              errMsg = errMsg + "「ランプスタート圧」に「EPAP最小圧」以下の値を設定してください。\n"
            }
            var flex = this.reqParams.prescriptionItems.find(val => val.displayName == "Flexタイプ" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(flex=="1"){
              // Bi-Flex
              if(Number(psMin.value)==0 && Number(psMax.value)==0){
                // 「PS最小圧≠0 または PS最大圧≠0 」でない場合
                errMsg = errMsg + "「PS最小圧」または「PS最大圧」に0以外の値を設定してください。\n"
              }
            }else if(flex=="2"){
              // C-Flex
              if(Number(psMin.value)!=0 || Number(psMax.value)!=0){
                // 「PS最小圧=0」且つ「PS最大圧=0」でない場合
                errMsg = errMsg + "「PS最小圧」「PS最大圧」に0を設定してください。\n"
              }
            }
          }
          break;
        case 5:
          // エスボックス バイスタルク
          var lampStart = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプ開始圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
          if(this.reqParams.mode == "4"){
            // CPAPモード
            // "ランプ開始圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
          }else if(this.reqParams.mode == "1"){
            // Auto CPAPモード
            var pressureMax = this.reqParams.prescriptionItems.find(val => val.displayName == "最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            var pressureMin = this.reqParams.prescriptionItems.find(val => val.displayName == "最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(Number(pressureMin.value) > Number(pressureMax.value)){
              // "最小圧【hPa(cmH2O)】" <= "最大圧【hPa(cmH2O)】" でない時
              errMsg = errMsg + "「最小圧」に「最大圧」以下の値を設定してください。\n"
            }
            if(Number(lampStart.value) > Number(pressureMin.value)){
              // "ランプ開始圧【hPa(cmH2O)】" <= "最小圧【hPa(cmH2O)】" でない時
              errMsg = errMsg + "「ランプ開始圧」に「最小圧」以下の値を設定してください。\n"
            }
          }
          break;
        case 6:
          // プリズマ ライン (prisma25S)
          if(this.reqParams.mode == "1"){
            // APAPモード
            var pressureMax = this.reqParams.prescriptionItems.find(val => val.displayName == "最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            var pressureMin = this.reqParams.prescriptionItems.find(val => val.displayName == "最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(Number(pressureMin.value) > Number(pressureMax.value)){
              // "最小圧【hPa(cmH2O)】" <= "最大圧【hPa(cmH2O)】" でない時
              errMsg = errMsg + "「最小圧」に「最大圧」以下の値を設定してください。\n"
            }
          }else if(this.reqParams.mode == "7"){
            // Sモード
            var epap = this.reqParams.prescriptionItems.find(val => val.displayName == "EPAP圧【hPa（cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            var ipap = this.reqParams.prescriptionItems.find(val => val.displayName == "IPAP圧【hPa（cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(Number(epap.value) > Number(ipap.value)){
              // "EPAP【hPa(cmH2O)】" <= "IPAP【hPa(cmH2O)】" で無い時
              errMsg = errMsg + "「EPAP」に「IPAP」以下の値を設定してください。\n"
            }
          }else if(this.reqParams.mode == "9"){
            // autoSモード
            var pdiffMin = this.reqParams.prescriptionItems.find(val => val.displayName == "PDIFF min 圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            var pdiffMax = this.reqParams.prescriptionItems.find(val => val.displayName == "PDIFF max 圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(Number(pdiffMin.value) > Number(pdiffMax.value)){
              // "PDIFF min 圧【hPa(cmH2O)】" <= "PDIFF max 圧【hPa(cmH2O)】" で無い時
              errMsg = errMsg + "「PDIFF min 圧」に「PDIFF max 圧」以下の値を設定してください。\n"
            }
          }
          break;
      }
      if(errMsg){
        // 相関チェックエラーの場合
        this.showErrorMessage(errMsg)
        return
      }
      var messsage = model.itemName
      messsage += "の処方を申込みます。<br/>機種が正しいことを確認して「OK」ボタンを押してください。"
      this.$dialog.confirm({
        title: "申込み確認",
        message: messsage,
        cancelText: "修正する",
        onConfirm: async () => {
          this.compleateFlg = false;
          var excuteApi = this.setCpapPrescriptionRequestPOST;
          var successCallBack = this.setCpapPrescriptionRequestPOSTSuccess;
          var errorCallBack = this.setCpapPrescriptionRequestPOSTError;
          // WebAPI Call
          await this.apiCall(excuteApi, successCallBack, errorCallBack)
          if(this.compleateFlg){
            this.jumpToTop();
            this.activeStep += 1;
          }
        }
      });
    },
    setCpapPrescriptionRequestPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.reqParams));
      obj.clientDate = new Date().toString();
      if (!obj.mailNotification) {
        obj.hospitalMail = ""
      }
      if(!obj.useModule){
        obj.moduleItemCode = ""
      }
      // 処方再開の場合
      let changedItems = []
      if(obj.kind == cpapKindMap.applicationResume){
        if(this.changeBeforeData){
          var moistAddFlag = false; //加湿器追加フラグ
          var modulAddFlag = false; //モデム追加フラグ
          // 加湿器追加時（無⇒有）
          if(obj.useMoist && !(this.changeBeforeData.useMoist)){
            moistAddFlag = true;
          }
          // モデム追加時（無⇒有）
          if(obj.useModule && !(this.changeBeforeData.useModule)){
            modulAddFlag = true;
          }
          // 変更した項目(値)をチェック
          for(var item of this.changedCheckItems){
            // 患者情報の場合は、チェック項目の階層が異なる
            var beforeTarget = item.key == "patientArea" ? this.changeBeforeData.patient : this.changeBeforeData
            var target = item.key == "patientArea" ? obj.patient : obj
            // 初期値セット
            var checkValue = {areaName:item.key, isChange:false, items:[]}

            if(item.key == "prescriptionArea"){
              // 設定情報の場合、全項目を順に比較
              var moistAreaValue = {areaName:"moistArea", isChange:false, items:[], moistAdd:moistAddFlag}
              var moduleAreaValue = {areaName:"moduleArea", isChange:false, items:[], modulAdd:modulAddFlag}
              if(this.changeBeforeData["reportFormatType"] != target["reportFormatType"]){
                // 機種変更している場合は、処方項目が異なる為比較不可
                checkValue.isChange = true
                moistAreaValue.isChange = true
                moduleAreaValue.isChange = true
                changedItems.push(checkValue)
                changedItems.push(moistAreaValue)
                changedItems.push(moduleAreaValue)
                continue
              }
              for(var prescription of target.prescriptionItems){
                let beforePrescription = this.changeBeforeData.prescriptionItems.find(v => v.displayOrder==prescription.displayOrder)
                if(beforePrescription && beforePrescription.value != prescription.value){
                  switch(prescription.category){
                    case 0:
                      // 本体
                      checkValue.isChange = true
                      checkValue.items.push({itemName:prescription.displayName, before:beforePrescription.value, after:prescription.value, displayOrder:prescription.displayOrder})
                      break;
                    case 1:
                      // 加湿器
                      moistAreaValue.isChange = true
                      moistAreaValue.items.push({itemName:prescription.displayName, before:beforePrescription.value, after:prescription.value, displayOrder:prescription.displayOrder})
                      break;
                    case 2:
                      // 通信モジュール
                      moduleAreaValue.isChange = true
                      moduleAreaValue.items.push({itemName:prescription.displayName, before:beforePrescription.value, after:prescription.value, displayOrder:prescription.displayOrder})
                      break;
                  }
                }
              }
              changedItems.push(checkValue)
              changedItems.push(moistAreaValue)
              changedItems.push(moduleAreaValue)
              continue
            }
            for(var val of item.value){
              if(beforeTarget[val] != target[val]) {
                checkValue.items.push({itemName:val, before:beforeTarget[val], after:target[val]})
                checkValue.isChange = true
              }
            }
            changedItems.push(checkValue)
          }
        }
      }
      obj.changedItems = changedItems
      obj.instructionDate = obj.instructionDate ? obj.instructionDate.replace(/-/g, "/") :""
      obj.patient.age = obj.patient.age+""
      obj.patient.birthday = obj.patient.birthday ? obj.patient.birthday.replace(/-/g, "/") :""
      if(obj.kind == cpapKindMap.applicationResume && this.reqParams.transferDestinationId){
        obj.belongsId = this.reqParams.transferDestinationId
        obj.institutionId = this.reqParams.transferInstitutionId ? this.reqParams.transferInstitutionId : null
      } else {
        obj.belongsId = this.belongsId
        obj.institutionId = this.institutionId
      }
      return client.apis.externalCpap.setCpapPrescriptionRequestPOST({
        body:obj
      });
    },
    setCpapPrescriptionRequestPOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.reqParams.applicationDate = result.obj.requestDate
      this.reqParams.applicationTime = result.obj.requestTime
      this.reqParams.applicationUserName = result.obj.requestUserName
      this.reqParams.receiptNumber = result.obj.receiptNumber
      this.reqParams.status = this.cpapRequestStatus.request
      // 再レンダリングの為、フラグ切替
      this.renderKey = !this.renderKey
      this.compleateFlg = true;
    },
    setCpapPrescriptionRequestPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    back: function() {
      if(this.backRoutName && !this.isInstrument){
        this.$router.push({
          name: this.backRoutName,
          params: this.backRoutParams,
        });
      } else if (this.isInstrument) {
        // 預託検索からの場合
        // 品質#20 20240404
        if(!this.isHospital && !this.isDealer){
          this.$router.push({ path: "/philips/cpap/CpapHome" });
        }else{
          this.$router.push({ path: "/guest/cpap/CpapMenu" });
        }
      }else{
        // 転院紹介の場合
        if(this.preReceiptNumber) {
          this.$router.push({ path: "/guest/home" });
        }else{
          if (this.isInstrument){
            // 預託検索からの場合
            // 品質#20 20240404
            if(!this.isHospital && !this.isDealer){
              this.$router.push({ path: "/philips/cpap/CpapHome" });
            }else{
              this.$router.push({ path: "/guest/cpap/CpapMenu" });
            }
          } else {
            this.$router.go(-1);
          }
        }
      }
    },
    goHome: function() {
      if (this.userInfo.belongsId) {
        this.$router.push({ path: "/guest/cpap/CpapMenu" });
      } else {
        this.back();
      }
    },
    changeModel: async function() {
      // 処方値の取得
      this.reqParams.prescriptionItems = []
      this.reqParams.useMoist = false
      this.reqParams.useModule = false
      this.reqParams.moduleItemCode = ""
      var model
      //QA75_仮持出中止から処方再開で本体変更処理後、表示が変わらない20240109
      if(this.temp){
        model = this.modelList.find(val => val.itemCodes && val.itemCodes.indexOf(this.reqParams.model) != -1)
      }
      if(!this.reqParams.reportFormatType && !this.reqParams.model){
        return
      }
      //QA75_仮持出中止から処方再開で本体変更処理後、表示が変わらない20240109
      if(!this.temp){
        if(this.reqParams.reportFormatType){
          model = this.modelList.find(val => val.reportFormatType == this.reqParams.reportFormatType)
        } else {
          model = this.modelList.find(val => val.itemCodes && val.itemCodes.indexOf(this.reqParams.model) != -1)
        }
      }
      // 20240215 類似品目選択時
      if(model){
        var modelItem = model.items.find(item => item.itemCode == this.reqParams.model)
        if(modelItem){
          this.reqParams.model = modelItem.itemCode
        }else{
          this.reqParams.model = model ? model.itemCode : ""
        }
      }else{
        this.reqParams.model = ""
      }
      this.reqParams.reportFormatType = model ? model.reportFormatType : ""
      var excuteApi = this.getPrescriptionValueItemsPOST;
      var successCallBack = this.getPrescriptionValueItemsPOSTSuccess;
      var errorCallBack = this.getPrescriptionValueItemsPOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getPrescriptionValueItemsPOST: function(client) {
      return client.apis.externalCpap.getPrescriptionValueItemsPOST({
        body:{
          formatType:this.reqParams.reportFormatType
        }
      });
    },
    getPrescriptionValueItemsPOSTSuccess: function(result) {
      this.reqParams.prescriptionItems = result.obj
      this.reqParams.useMoist = true
      this.reqParams.useModule = true
      var setItem = this.cpapSetItems.find(val => val.cpapItemCode == this.reqParams.model)
      if(setItem.module){
        this.moduleList = setItem.module
      }else{
        this.moduleList = ""
        this.reqParams.moduleItemCode = setItem.moduleItemCode
      }
      for(var i=0; i<this.reqParams.prescriptionItems.length; i++){
        var item = this.reqParams.prescriptionItems[i]
        if(item.type=== 'calender'){
          item.value = this.yyyy_hyp_MM_hyp_dd(new Date())
        }
        if(item.displayName == "モード" && item.defaultValue){
          this.reqParams.mode = item.defaultValue
          continue
        }
        if(item.type=="radio" && item.value=="0"){
          if(item.category==1) this.reqParams.useMoist = false
          if(item.category==2) this.reqParams.useModule = false
        }
        this.changeSelect(item.displayName,item.value,item.itemName)
      }
    },
    getPrescriptionValueItemsPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    inputRadioValue: function(result,name){
      switch(name){
        case "useMoist":
          this.reqParams.useMoist = result=="1"
          break;
        case "useModule":
          this.reqParams.useModule = result=="1"
          this.reqParams.moduleItemCode = ""
          break;
      }
    },
    setOrganization: function(organizationInfo){
      this.reqParams.belongsId = organizationInfo.id + "";
      this.reqParams.medicalInstitutionName = organizationInfo.orgName;
      this.reqParams.receiverName = organizationInfo.orgName;
      this.reqParams.resultReceiverName = organizationInfo.orgName;
      this.reqParams.zip = organizationInfo.zip;
      this.reqParams.address = organizationInfo.prefecture + organizationInfo.city;
      this.reqParams.address1 = organizationInfo.address;
      this.reqParams.address2 = organizationInfo.building ? organizationInfo.building : "";
      this.reqParams.phoneNumber = organizationInfo.phoneNumber;
      this.reqParams.note = organizationInfo.note;

      if (!this.belongsId || this.belongsId != organizationInfo.id) {
        // 代理申込時
        this.belongsId = organizationInfo.id
        this.getCpapDefaultsettings();
      }
      // 前回申込み情報の取得
      // this.prevHstSearchParam.belongsId = this.belongsId
    },
    setfacility:  function(facility){
      this.reqParams.institutionId = facility.id + "";
      this.reqParams.medicalInstitutionName = facility.orgName;

      this.reqParams.receiverName = facility.orgName;
      this.reqParams.resultReceiverName = facility.orgName;

      this.reqParams.zip = facility.postcode;
      this.reqParams.address = facility.prefecture + facility.address;
      this.reqParams.address1 = facility.houseNumber;
      this.reqParams.address2 = facility.building ? facility.building : "";
      this.reqParams.phoneNumber = facility.phoneNumber;

      // 前回申込み情報の取得
      // this.prevHstSearchParam.institutionId = facility.id
      this.institutionId = facility.id
      this.getCpapDefaultsettings();
    },
    print: function(){
      window.print();
    },
    inputBirthday: function(birthday){
      var age = this.getAge(birthday)
      if(!isNaN(Number(age))){
        this.reqParams.patient.age = age < 0 ? 0 : age
        const date = new Date(birthday);
        const options = {era: 'long'};
        this.reqParams.patient.japaneseCalendar = "【"+this.getJapaneseCalendar(date)+"】"
      }else{
        this.reqParams.patient.age = ""
      }
    },
    patientAddressSearch: function(val){
      // 検索対象の郵便番号を設定
      this.searchTargetPostCode = val
      this.searchTargetAddress = null
      this.postCodeSearch().then(result=>{
        if (!this.searchTargetAddress) return;
        this.reqParams.patient.address = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
        this.reqParams.patient.address1 = ""
        this.reqParams.patient.address2 = ""
        // 再レンダリングの為、フラグ切替
        this.renderKey = !this.renderKey
      })
    },
    addressSearch: function(target,val){
      // 検索対象の郵便番号を設定
      this.searchTargetPostCode = val
      this.searchTargetAddress = null
      this.postCodeSearch().then(result=>{
        if (!this.searchTargetAddress) return; 
        if(target!="result"){
          this.reqParams.address = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
          this.reqParams.address1 = ""
          this.reqParams.address2 = ""
        }
      })
    },
    postCodeSearch: function(){
      var excuteApi = this.getAddressFromPostCodePOST;
      var successCallBack = this.getAddressFromPostCodePOSTSuccess;
      var errorCallBack = this.getAddressFromPostCodePOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getAddressFromPostCodePOST: function(client) {
      return client.apis.apiCommon.getAddressFromPostCodePOST({
        body:{
          postCode:this.searchTargetPostCode
        }
      });
    },
    getAddressFromPostCodePOSTSuccess: function(result) {
      this.searchTargetAddress = result.obj
      this.searchTargetPostCode = ""
    },
    getAddressFromPostCodePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.searchTargetPostCode = ""
    },   
    getChoicesList: async function() {
      this.modelList = this.getCpapMaster();
      this.modelList.unshift({})
    },
    focusLostPatientFirstName: function(index) {
      if(!this.reqParams.patient.receiverName || this.reqParams.patient.receiverName==""){
        this.reqParams.patient.receiverName = this.reqParams.patient.patientFamilyName + " " + this.reqParams.patient.patientFirstName
        // 再レンダリングの為、フラグ切替
        this.renderKey = !this.renderKey
      }
    },
    changeSelect: function(name, value) {
      if(name == "モード"){
        this.reqParams.mode = value
        return
      }
      var model = this.modelList.find(val => val.itemCodes && val.itemCodes.indexOf(this.reqParams.model) != -1)
      switch(model.reportFormatType){
        case 1:
          // ドリームステーションAuto
          if(name == "Flexタイプ"){
            // "Flex設定"
            var flex = this.reqParams.prescriptionItems.find(val => val.displayName == "Flex設定" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="0"){
              flex.value = ""
              flex.disabled = true
            }else{
              flex.value = flex.defaultValue
              flex.disabled = false
            }
            return
          }
          if(name == "加湿モード"){
            // 回路温度設定
            var circuit = this.reqParams.prescriptionItems.find(val => val.displayName == "回路温度設定" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="0" || value=="1"){
              circuit.value = ""
              circuit.disabled = true
            }else{
              circuit.value = circuit.defaultValue
              circuit.disabled = false
            }
            return
          }
          if(name == "患者情報管理"){
            // 登録方法
            var registMethod = this.reqParams.prescriptionItems.find(val => val.displayName == "登録方法" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="0"){
              registMethod.value = ""
              registMethod.disabled = true
            }else{
              registMethod.value = registMethod.defaultValue
              registMethod.disabled = false
            }
            return
          }
          if(name == "ランプ時間【分】"){
            // ランプスタート圧【hPa(cmH2O)】
            var lampStart = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="0"){
              lampStart.value = "4"
              lampStart.disabled = true
            }else{
              lampStart.disabled = false
            }
            return
          }
          break;
        case 2:
          // ドリームステーションPro
          if(name == "Flexタイプ"){
            // "Flex設定"
            var flex = this.reqParams.prescriptionItems.find(val => val.displayName == "Flex設定" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="0"){
              flex.value = ""
              flex.disabled = true
            }else{
              flex.value = flex.defaultValue
              flex.disabled = false
            }
            return
          }
          if(name == "加湿モード"){
            // 回路温度設定
            var circuit = this.reqParams.prescriptionItems.find(val => val.displayName == "回路温度設定" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="0" || value=="1"){
              circuit.value = ""
              circuit.disabled = true
            }else{
              circuit.value = circuit.defaultValue
              circuit.disabled = false
            }
            return
          }
          if(name == "患者情報管理"){
            // 登録方法
            var registMethod = this.reqParams.prescriptionItems.find(val => val.displayName == "登録方法" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="0"){
              registMethod.value = ""
              registMethod.disabled = true
            }else{
              registMethod.value = registMethod.defaultValue
              registMethod.disabled = false
            }
            return
          }
          if(name == "ランプ時間【分】"){
            // ランプスタート圧【hPa(cmH2O)】
            var lampStart = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="0"){
              lampStart.value = "4"
              lampStart.disabled = true
            }else{
              lampStart.disabled = false
            }
            return
          }
          break;
        case 3:
          // ドリームステーションGo
          if(name == "Flexタイプ"){
            // "Flex設定"
            var flex = this.reqParams.prescriptionItems.find(val => val.displayName == "Flex設定" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="0"){
              flex.value = ""
              flex.disabled = true
            }else{
              flex.value = flex.defaultValue
              flex.disabled = false
            }
            return
          }
          if(name == "患者情報管理"){
            // 登録方法
            var registMethod = this.reqParams.prescriptionItems.find(val => val.displayName == "登録方法" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="0"){
              registMethod.value = ""
              registMethod.disabled = true
            }else{
              registMethod.value = registMethod.defaultValue
              registMethod.disabled = false
            }
            return
          }
          if(name == "ランプ時間【分】"){
            // ランプスタート圧【hPa(cmH2O)】
            var lampStart = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="0"){
              lampStart.value = "4"
              lampStart.disabled = true
            }else{
              lampStart.disabled = false
            }
            return
          }
          break;
        case 4:
          // ドリームステーションBiPAP Auto
          if(name == "Flexタイプ"){
            // "Flex設定"
            var flex = this.reqParams.prescriptionItems.find(val => val.displayName == "Flex設定" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            // "ライズタイム"
            var riseTime = this.reqParams.prescriptionItems.find(val => val.displayName == "ライズタイム" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            // "ライズタイムロック"
            var riseTimeLock = this.reqParams.prescriptionItems.find(val => val.displayName == "ライズタイムロック" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="0"){
              flex.value = ""
              flex.disabled = true
              riseTime.value = riseTime.defaultValue
              riseTimeLock.value = riseTimeLock.defaultValue
              riseTime.disabled = false
              riseTimeLock.disabled = false
            }else{
              flex.value = flex.defaultValue
              flex.disabled = false
              riseTime.value = ""
              riseTimeLock.value = ""
              riseTime.disabled = true
              riseTimeLock.disabled = true
            }
            return
          }
          if(name == "加湿モード"){
            // 回路温度設定
            var circuit = this.reqParams.prescriptionItems.find(val => val.displayName == "回路温度設定" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="0" || value=="1"){
              circuit.value = ""
              circuit.disabled = true
            }else{
              circuit.value = circuit.defaultValue
              circuit.disabled = false
            }
            return
          }
          if(name == "患者情報管理"){
            // 登録方法
            var registMethod = this.reqParams.prescriptionItems.find(val => val.displayName == "登録方法" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="0"){
              registMethod.value = ""
              registMethod.disabled = true
            }else{
              registMethod.value = registMethod.defaultValue
              registMethod.disabled = false
            }
            return
          }
          if(name == "ランプ時間【分】"){
            // ランプスタート圧【hPa(cmH2O)】
            var lampStart = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="0"){
              lampStart.value = "4"
              lampStart.disabled = true
            }else{
              lampStart.disabled = false
            }
            return
          }
          break;
        case 5:
          // エスボックス バイスタルク
          if(name == "CC+"){
            // "CC+機能有効時間　全治療時間"
            var ccAll = this.reqParams.prescriptionItems.find(val => val.displayName == "CC+機能有効時間　全治療時間" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            // "CC+機能有効時間　ランプのみ"
            var ccLamp = this.reqParams.prescriptionItems.find(val => val.displayName == "CC+機能有効時間　ランプのみ" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="0"){
              ccAll.value = ""
              ccLamp.value = ""
              ccAll.disabled = true
              ccLamp.disabled = true
            }else{
              ccAll.value = ""
              ccAll.disabled = true
              ccLamp.value = ccLamp.defaultValue
              ccLamp.disabled = false
            }
            return
          }
          if(name == "CC+機能有効時間　全治療時間"){
            // "CC+機能有効時間　全治療時間"
            var ccAll = this.reqParams.prescriptionItems.find(val => val.displayName == "CC+機能有効時間　全治療時間" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            // "CC+機能有効時間　ランプのみ"
            var ccLamp = this.reqParams.prescriptionItems.find(val => val.displayName == "CC+機能有効時間　ランプのみ" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value!="" && value!=null && value!="null"){
              // "CC+機能有効時間　ランプのみ"　非活性
              ccLamp.value = ""
              ccLamp.disabled = true
            }else{
              ccLamp.value = ccLamp.defaultValue
              ccLamp.disabled = false
              ccAll.disabled = true
            }
            return
          }
          if(name == "CC+機能有効時間　ランプのみ"){
            // "CC+機能有効時間　全治療時間"
            var ccAll = this.reqParams.prescriptionItems.find(val => val.displayName == "CC+機能有効時間　全治療時間" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            // "CC+機能有効時間　ランプのみ"
            var ccLamp = this.reqParams.prescriptionItems.find(val => val.displayName == "CC+機能有効時間　ランプのみ" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value!="" && value!=null && value!="null"){
              ccAll.value = ""
              ccAll.disabled = true
            }else{
              ccAll.value = ccAll.defaultValue
              ccAll.disabled = false
              ccLamp.disabled = true
            }
            return
          }
          if(name == "ランプ機能"){
            // "ランプタイム"
            var lampTime = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプタイム" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            // "ランプ時間【分】"
            var lampTimeMinutes = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプ時間【分】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            // "ランプ開始圧【hPa(cmH2O)】"
            var lampStart = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプ開始圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="0"){
              lampTime.value = ""
              lampTimeMinutes.value = ""
              lampStart.value = ""
              lampTime.disabled = true
              lampTimeMinutes.disabled = true
              lampStart.disabled = true
            }else{
              lampTime.value = lampTime.defaultValue
              lampTimeMinutes.value = lampTimeMinutes.defaultValue
              lampStart.value = lampStart.defaultValue
              lampTime.disabled = false
              lampTimeMinutes.disabled = false
              lampStart.disabled = false
            }
            return
          }
          if(name == "ランプタイム"){
            // "ランプ時間【分】"
            var lampTimeMinutes = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプ時間【分】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="1"){
              lampTimeMinutes.value = ""
              lampTimeMinutes.disabled = true
            }else{
              // ランプ機能
              var lamp = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプ機能" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
              if(lamp.value!="0"){
                lampTimeMinutes.value = lampTimeMinutes.defaultValue
                lampTimeMinutes.disabled = false
              }
            }
            return
          }
          if(name == "患者情報管理"){
            // 登録方法
            var registMethod = this.reqParams.prescriptionItems.find(val => val.displayName == "登録方法" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="0"){
              registMethod.value = ""
              registMethod.disabled = true
            }else{
              registMethod.value = registMethod.defaultValue
              registMethod.disabled = false
            }
            return
          }
          break;
        case 6:
          // プリズマ ライン (prisma25S)
          break;
      }
    },
    getAgreementStr: async function() {
      var excuteApi = this.getConsentStatementPOST;
      var successCallBack = this.getConsentStatementPOSTSuccess;
      var errorCallBack = this.getConsentStatementPOSTError;
      // WebAPI Call
      await this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getConsentStatementPOST: function(client) {
      var type = this.consentStatement.cpap;
      return client.apis.apiCommon.getConsentStatementPOST({
        body: {
          type: type
        } 
      });
    },
    getConsentStatementPOSTSuccess: function(result) {
      if(result.body.contents != ""){
        this.agreement = result.body.contents;
        this.canAgree = true;
      } else {
        this.agreement = "利用規約が登録されていません。";
      }
    },
    getConsentStatementPOSTError: function(result) {
      this.agreement == "利用規約を取得できませんでした。";
    },
    getMaskMaster: function() {
      var model = this.modelList.find(val => val.itemCodes && val.itemCodes.indexOf(this.reqParams.model) != -1)
      if(model){
        this.formatType = model.reportFormatType
        this.maskSelectModalActive=true
      }else{
        this.showErrorMessage("CPAP機種が選択されていません。")
      }
    },
    maskSelect: function(maskInfo) {
      this.reqParams.maskId = maskInfo.id
      this.reqParams.maskType = maskInfo.maskType
      this.reqParams.maskItemCode = maskInfo.itemCode1
      this.reqParams.cushionSize = maskInfo.cushionSize
      this.reqParams.frameSize = maskInfo.frameSize
      this.reqParams.fixingMethod = maskInfo.fixingMethod
    },
    tempDeviceSelect: function(deviceInfo) {
      this.reqParams.tempDeviceId = deviceInfo.id
      this.reqParams.model = deviceInfo.itemCode
      this.reqParams.serial = deviceInfo.serial
      this.reqParams.provisionalTakenOutItems = [deviceInfo]
      this.changeModel()
    },
    getApplication: async function() {
      if(this.preKind == 'hst') {
        var excuteApi = this.getHstRequestDetailPOST;
        var successCallBack = this.getHstRequestDetailPOSTSuccess;
        var errorCallBack = this.getHstRequestDetailPOSTError;
        // WebAPI Call
        await this.apiCall(excuteApi, successCallBack, errorCallBack);
      } else if (this.preKind == 'psg') {
        var excuteApi = this.getAnalysisDetailPOST;
        var successCallBack = this.getAnalysisDetailPOSTSuccess;
        var errorCallBack = this.getAnalysisDetailPOSTError;
        // WebAPI Call
        await this.apiCall(excuteApi, successCallBack, errorCallBack);
      }
    },
    getHstRequestDetailPOST: function(client) {
      return client.apis.internalHst.getHstRequestDetailPOST({
        body:{
          receiptNumber:this.preReceiptNumber,
        }
      });
    },
    getHstRequestDetailPOSTSuccess: function(result) {
      var obj = result.obj.applicationDetails

      this.reqParams.doctorName = obj.doctorName
      this.reqParams.clerkName = obj.clerkName
      this.reqParams.patient.patientRegistrationCard = obj.patientsData[0].patientId
      this.reqParams.patient.patientFamilyName = obj.patientsData[0].patientFamilyName
      this.reqParams.patient.patientFirstName = obj.patientsData[0].patientFirstName
      this.reqParams.patient.patientFamilyNameKana = obj.patientsData[0].patientFamilyNameKana
      this.reqParams.patient.patientFirstNameKana = obj.patientsData[0].patientFirstNameKana
      this.reqParams.patient.gender = obj.patientsData[0].gender
      this.reqParams.patient.birthday = obj.patientsData[0].birthday ? obj.patientsData[0].birthday.replace(/\//g, "-") : ""

      this.reqParams.patient.zip = obj.patientsData[0].zip
      this.reqParams.patient.address = obj.patientsData[0].address
      this.reqParams.patient.address1 = obj.patientsData[0].address1
      this.reqParams.patient.address2 = obj.patientsData[0].address2
      this.reqParams.patient.receiverName = obj.patientsData[0].receiverName
      this.reqParams.patient.phoneNumber = obj.patientsData[0].phoneNumber
      this.reqParams.patient.mobilePhone = obj.patientsData[0].mobilePhone
    },
    getHstRequestDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getAnalysisDetailPOST: function(client) {
      return client.apis.externalAnalysis.getAnalysisDetailPOST({
        body:{
          receiptNumber:this.preReceiptNumber,
        }
      });
    },
    getAnalysisDetailPOSTSuccess: function(result) {
      var obj = result.obj.requestDetails

      this.reqParams.doctorName = obj.doctorName
      this.reqParams.clerkName = obj.clerkName
      this.reqParams.patient.patientRegistrationCard = obj.patientId
      this.reqParams.patient.patientFamilyName = obj.patientFamilyName
      this.reqParams.patient.patientFirstName = obj.patientFirstName
      this.reqParams.patient.patientFamilyNameKana = obj.patientFamilyNameKana
      this.reqParams.patient.patientFirstNameKana = obj.patientFirstNameKana
      this.reqParams.patient.gender = obj.gender
      this.reqParams.patient.birthday = obj.birthday ? obj.birthday.replace(/\//g, "-") : ""
      this.reqParams.patient.age = ""
    },
    getAnalysisDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getCpapDefaultsettings: async function() {
      this.cpapBeforeRequestDetail = null;
      var excuteApi = this.getCpapDefaultsettingsPOST;
      var successCallBack = this.getCpapDefaultsettingsPOSTSuccess;
      var errorCallBack = this.getCpapDefaultsettingsPOSTError;
      // WebAPI Call
      await this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getCpapDefaultsettingsPOST: function(client) {
      return client.apis.externalCpap.getCpapDefaultsettingsPOST({
        body:{
          belongsId : this.belongsId,
          institutionId : this.institutionId
        }
      });
    },
    getCpapDefaultsettingsPOSTSuccess: function(result) {
      this.cpapBeforeRequestDetail = result.obj
    },
    getCpapDefaultsettingsPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    cpapPreviousRequestCopy: function() {
      this.$dialog.confirm({
        title: "デフォルト設定値反映確認",
        message: "下記情報にデフォルト設定情報を反映します。<br>（更新がある場合は手動入力にて変更を行ってください）<br>・医療機関情報<br>・装置情報<br>・設定情報<br>・納品先情報",
        cancelText: "キャンセル",
        onConfirm: async () => {
          // 医師名
          this.reqParams.doctorName = this.cpapBeforeRequestDetail.doctorName
          // 事務担当者名
          this.reqParams.clerkName = this.cpapBeforeRequestDetail.clerkName
          // 医療機関へのメール送付(ディーラー代理)
          this.reqParams.mailNotification = this.cpapBeforeRequestDetail.mailNotification
          // 医療機関メールアドレス(ディーラー代理)
          this.reqParams.hospitalMail = this.cpapBeforeRequestDetail.mail
          // 機種
          this.reqParams.reportFormatType = this.cpapBeforeRequestDetail.reportFormatType
          this.reqParams.model = this.cpapBeforeRequestDetail.itemCode
          // 処方設定
          this.reqParams.prescriptionItems = this.cpapBeforeRequestDetail.prescriptionContent
          // 20230927 デフォルト設定一律で設置日に当日日付を設定
          // 加温加湿器：設置日,通信モジュール：設置日
          for(var item of this.reqParams.prescriptionItems){
            if(item.displayName.indexOf("設置日") == -1) continue
            //処方再開(中止)の場合は設置日を空に、それ以外は本日日付を入力
            item.value = this.yyyy_hyp_MM_hyp_dd(new Date())
          }
          // モード
          this.reqParams.mode = this.cpapBeforeRequestDetail.mode
          // 加湿器有無
          this.reqParams.useMoist = this.cpapBeforeRequestDetail.useMoist
          // 通信モジュール有無
          this.reqParams.useModule = this.cpapBeforeRequestDetail.useModule
          // マスク情報
          this.reqParams.maskId = this.cpapBeforeRequestDetail.maskId
          this.reqParams.maskType = this.cpapBeforeRequestDetail.maskType
          this.reqParams.maskItemCode = this.cpapBeforeRequestDetail.maskItemCode
          this.reqParams.cushionSize = this.cpapBeforeRequestDetail.cushionSize
          this.reqParams.frameSize = this.cpapBeforeRequestDetail.frameSize
          this.reqParams.fixingMethod = this.cpapBeforeRequestDetail.fixingMethod
          this.reqParams.memo = this.cpapBeforeRequestDetail.maskMemo ? this.cpapBeforeRequestDetail.maskMemo : ""
          // 納品先情報(患者宅/医療機関)
          this.reqParams.delivaryTarget = this.cpapBeforeRequestDetail.delivaryTarget
          // if(this.reqParams.delivaryTarget== 'hospital'){
            // this.reqParams.zip = this.cpapBeforeRequestDetail.zip
            // this.reqParams.address = this.cpapBeforeRequestDetail.address
            // this.reqParams.address1 = this.cpapBeforeRequestDetail.address1
            // this.reqParams.address2 = this.cpapBeforeRequestDetail.address2
            // this.reqParams.receiverName = this.cpapBeforeRequestDetail.receiverName
            // this.reqParams.phoneNumber = this.cpapBeforeRequestDetail.phoneNumber
          // }
        }
      });
    },
    download: function() {
      this.$store.dispatch("downloadConsentStatement", {
          type: this.consentStatement.cpap,
          uid: this.userInfo.id
      }).then(result => {
          if(!result.status || result.status != 200){
              if(result.obj){
                  this.showErrorMessage(result.obj.message);
              } else {
                  this.showErrorMessage(result.message);
              }
          }
      }).catch(error => {
          this.showErrorMessage(error);
      });
    },
    getEscrowStock: async function() {
      var excuteApi = this.getEscrowStockPOST;
      var successCallBack = this.getEscrowStockPOSTSuccess;
      var errorCallBack = this.getEscrowStockPOSTError;
      // WebAPI Call
      await this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getEscrowStockPOST: function(client) {
      return client.apis.externalCpap.getEscrowStockPOST({
        body:{
          hospitalCode:this.medicalInstitutionCode,
        }
      });
    },
    getEscrowStockPOSTSuccess: function(result) {
      this.escrowStockList = result.body.map((value) => value.items).flat();
      this.stockItemNameList = this.escrowStockList.map((value) => value.itemName);
      this.stockItemCodeList = this.escrowStockList.map((value) => value.itemCode);
      this.stockItemSeialList = this.escrowStockList.map((value) => value.serial);
    },

    async setDraftDate(params) {
      // hospital info
      this.isPatientAgree = true;
      this.reqParams.medicalInstitutionName = params.medicalInstitutionName;
      this.reqParams.doctorName = params.doctorName;
      this.reqParams.clerkName = params.clerkName;
      // patient info
      this.reqParams.patient.patientRegistrationCard = params.patientCardId;
      this.reqParams.patient.patientFamilyName = params.patientLastName;
      this.reqParams.patient.patientFirstName = params.patientFirstName;
      this.reqParams.patient.patientFamilyNameKana = params.patientLastNameKana;
      this.reqParams.patient.patientFirstNameKana = params.patientFirstNameKana;
      this.reqParams.patient.gender = params.patientGender;
      this.reqParams.patient.birthday = params.patientBirthday;
      this.reqParams.patient.receiverName = params.patientReceiverName;
      this.reqParams.patient.zip = params.patientPostCode;
      this.reqParams.patient.address = params.patientAddress;
      this.reqParams.patient.address1 = params.patientAddressHouseNumber;
      this.reqParams.patient.address2 = params.patientAddressBuildingName;
      this.reqParams.patient.mobilePhone = params.patientMobilePhoneNumber;
      this.reqParams.patient.phoneNumber = params.patientOtherPhoneNumber;
      this.reqParams.patient.followUpCall = params.isEnabledFollowUpCall;
      this.reqParams.patient.disease = params.diseaseName;
      this.reqParams.patient.infection = params.infectionType;
      this.reqParams.patient.infectionName = params.infectionName;
      this.reqParams.patient.hospitalName = params.regionalInstitutionName;
      this.reqParams.patient.doctorName = params.regionalDoctorName;
      // delivery info
      this.reqParams.delivaryTarget = this.convertDestType(params.destType);
      if(params.destType == "2") {
        this.reqParams.zip = params.destPostCode;
        this.reqParams.address = params.destAddress;
        this.reqParams.address1 = params.destAddressHouseNumber;
        this.reqParams.address2 = params.destAddressBuildingName;
        this.reqParams.receiverName = params.destReceiverName;
        this.reqParams.phoneNumber = params.destPhoneNumber;
      }
      // other
      this.reqParams.memo = params.remarks;
      // device info
      this.reqParams.reportFormatType = params.deviceFormatType;
      let model = this.modelList.find(val => val.reportFormatType == this.reqParams.reportFormatType);
      this.reqParams.model = model.itemCode
      this.reqParams.prescriptionItems = params.deviceSettingInfo;
      for(var screenItem of this.reqParams.prescriptionItems) {
        if(screenItem.displayOrder == 1) {
            this.reqParams.mode = screenItem.value
        }
        if(screenItem.displayName == "加温加湿器") {
          this.reqParams.useMoist = screenItem.value == 1;
        }
        if(screenItem.displayName == "通信モジュール") {
          this.reqParams.useModule = screenItem.value == 1;
        }
      }
      if (this.reqParams.model == "RJPG500S16") {
        this.reqParams.useModule = true;
      }
      this.reqParams.maskId = params.maskId;
      this.reqParams.maskType = params.maskType;
      this.reqParams.cushionSize = params.maskCushionSize;
      this.reqParams.frameSize = params.maskFrameSize;
      this.reqParams.fixingMethod = params.maskFixingMethod;
      this.reqParams.maskItemCode = params.maskItemCode1;
      this.reqParams.tempReceptionNo = params.tempReceptionNo;
      // forward step.
      this.activeStep = 5;
    },
  },
  data() {
    var applicationType = cpapKindMap.application
    // 処方再開(転院)判定
    var resume = false;
    if(this.$route.params["resume"]){
      resume = this.$route.params["resume"];
      applicationType = cpapKindMap.applicationResume
    }
    // 処方変更の際、変更した項目のチェック用定義
    var changedCheckItems = [
      {key:"basicArea", value:["instructionDate","contractEndDate","billingCurrentMonth","cancelReasonCode","depositContractEndDate","depositCancelReasonCode","depositBillingCurrentMonth","doctorName","clerkName","hospitalMail"]},
      {key:"patientArea", value:["patientRegistrationCard","patientFamilyName","patientFirstName","patientFamilyNameKana","patientFirstNameKana","gender","birthday","zip","address","address1","address2","receiverName","mobilePhone","phoneNumber","followUpCall","disease","infection","infectionName","hospitalName","doctorName"]},
      {key:"hardwareArea", value:["reportFormatType","serial","settingChanger"]},
      {key:"prescriptionArea", value:[]},
      // {key:"moistArea", value:[]},
      // {key:"moduleArea", value:[]},
      {key:"maskArea", value:["maskType","cushionSize","frameSize","fixingMethod","lot"]},
      {key:"orderArea", value:["billingStartDate","billComment","departmentCode","customerClass","directShippingType","leaseUpType","memo"]}
    ]
    // 処方再開(中止から)判定
    var cancelResume = false;
    if(this.$route.params["cancelResume"]){
      cancelResume = this.$route.params["cancelResume"];
    }
    // 仮持出申込み判定
    var temp = false;
    if(this.$route.params["temp"]){
      temp = this.$route.params["temp"];
      applicationType = cpapKindMap.applicationTempRemoval
    }
    // 預託在庫からの申込み判定
    var isInstrument = false;
    if(this.$route.params["instrument"]){
      isInstrument = this.$route.params["instrument"];
    }
    // 処方変更判定
    var changePrescription = false;
    if(this.$route.params["changePrescription"]){
      changePrescription = this.$route.params["changePrescription"];
      applicationType = cpapKindMap.applicationChange
    }
    // 継続申請/転院紹介
    var preReceiptNumber = this.$route.params["receiptNumber"];
    var preKind = this.$route.params["kind"];
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId;
    var userId = userInfo.id;
    var miniday = new Date()
    var maxDate = new Date()
    maxDate.setDate(maxDate.getDate() + 365);
    var maxday = new Date(maxDate.getFullYear(), maxDate.getMonth(), maxDate.getDate());
    var isDealer = roleId == role.role_dealer;
    var isSalesOffice = roleId == role.role_salesOffice;
    var isHospital = roleId == role.role_hospital;
    var isHonsha = roleId == role.role_headOffice;
    var isAdmin = roleId == role.role_admin;
    var belongsId = userInfo.belongsId
    var institutionId
    var reqParams = {
      instructionDate:this.yyyy_hyp_MM_hyp_dd(new Date()),
      serial:"",
      mode:"",
      useMoist:false,
      useModule:false,
      isDealer: isDealer,
      medicalInstitutionName: isHospital ? userInfo.medicalInstitutionName + " " + userInfo.departmentName : "",
      doctorName: "",
      clerkName:"",
      mailNotification:false,
      hospitalMail:"",
      zip:isHospital ? userInfo.postcode : "",
      address:isHospital ? userInfo.prefecture + " " + userInfo.city : "",
      address1:isHospital ? userInfo.address : "",
      address2:isHospital ? userInfo.building : "",
      receiverName:isHospital ? userInfo.medicalInstitutionName + " " + userInfo.departmentName : "",
      phoneNumber:isHospital ? userInfo.phoneNumber : "",
      desiredDeliveryTimeZone:"",
      model:"",
      depositUseFlag:isInstrument,
      settingChanger:0,
      delivaryTarget:"hospital",
      returnDate:"",
      shippingDate:null,
      deliverySlip:false,
      // institutionId: "",
      patient: {
        patientRegistrationCard:"",
        patientFamilyName:"",
        patientFirstName:"",
        patientFamilyNameKana:"",
        patientFirstNameKana:"",
        gender:"-",
        birthday:"",
        age:"",
        japaneseCalendar:"",
        followUpCall: true,
        disease:"",
        infectionFlag: false,
        infectionName: "",
        hospitalName: "",
        doctorName: "",
        zip: "",
        address:"",
        address1:"",
        address2:"",
        receiverName:"",
        phoneNumber:"",
        disease:""
      },
      prescriptionItems:[],
      memo:"",
      status:cpapRequestStatus.request,
      kind:applicationType,
      moduleItemCode:"",
      // 加湿器、通信モジュール(シリアル)
      moistSerial:"",
      moduleSerial:"",
      // マスク関連
      maskId:0,
      maskType:"",
      maskItemCode:"",
      cushionSize:"",
      frameSize:"",
      fixingMethod:"",
      // 処方再開(転院)
      resume:resume,
      // 処方再開(中止)
      cancelResume:cancelResume,
      // 仮持出
      temp:temp,
      // 預託在庫からの処方
      isInstrument:isInstrument,
      // 処方変更
      changePrescription:changePrescription,
    }
    var changeBeforeData = null;
    
    // 転院患者の処方再開(元データ)
    var patientData = this.$route.params["selectedData"];
    var backRoutName = this.$route.params["name"];
    var backRoutParams = this.$route.params;
    if(patientData){
      reqParams = patientData
      reqParams.instructionDate = this.yyyy_hyp_MM_hyp_dd(new Date())
      reqParams.applicationDate = ""
      reqParams.applicationTime = ""
      reqParams.applicationUserName = ""
      reqParams.receiptNumber = ""
      reqParams.status = cpapRequestStatus.request
      // reqParams.kind = cpapKindMap.application
      reqParams.kind = cpapKindMap.applicationResume
      if (backRoutParams.isEscrow) {
        reqParams.depositUseFlag = true;
      }
      if(!resume || cancelResume){
        belongsId = reqParams.belongsId
        institutionId = reqParams.institutionId
      }else if (resume && !cancelResume){
        // 転院後の再開の場合
        belongsId = reqParams.belongsId
        institutionId = reqParams.transferInstitutionId ? reqParams.transferInstitutionId : ""
        reqParams.medicalInstitutionName = reqParams.transferDestinationName
        reqParams.receiverName = reqParams.transferDestinationName
        reqParams.doctorName = ""
        reqParams.patient.patientRegistrationCard = ""
      }
      // 処方再開(転院)
      reqParams.resume = resume
      // 処方再開(中止)
      reqParams.cancelResume = cancelResume
      // 仮持出
      reqParams.temp = temp
      // 預託在庫からの処方
      reqParams.isInstrument = isInstrument
      // 処方変更
      reqParams.changePrescription = changePrescription
      delete reqParams.billingStartDate
      for(var item of reqParams.prescriptionItems){
        if(item.displayName.indexOf("設置日") == -1) continue
        if (resume && !cancelResume){
          item.value = this.yyyy_hyp_MM_hyp_dd(new Date())
        }else{
          item.value = ""
        }
      }
      changeBeforeData = JSON.parse(JSON.stringify(reqParams));
    }
    var cpapAccessories = this.getCpapAccessoryList();
    var cpapSetItems = this.getCpapSetItemList();
    return {
      role: role,
      roleId: roleId,
      userId: userId,
      choicesType:choicesType,
      extUserStatus: extUserStatus,
      belongsId,
      institutionId,
      userInfo: userInfo,
      lendingPeriod:LendingPeriod.period,
      organizationModalActive: false,
      isChecked: false,
      activeStep: 0,
      prevRouteName: "",
      isHospitalAgree: roleId != role.role_dealer,
      isPatientAgree: !isDealer && !isHospital,
      isDealer: isDealer,
      isSalesOffice: isSalesOffice,
      isHonsha: isHonsha,
      isAdmin: isAdmin,
      miniday: miniday,
      maxday:maxday,
      disabledDays: [],
      reqParams,
      compleateFlg:false,
      searchTargetPostCode:"",
      searchTargetAddress:null,
      requestDate:"",
      receiptNumber:"",
      renderKey:true,
      canAgree:false,
      consentStatement:consentStatement,
      modelList:[],
      desiredDeliveryTimeZoneList:[],
      cannulaSizeList:[],
      beltSizeList:[],
      attachedWaveformList:[],
      isHospital,
      inspectionPurposeList:[],
      temp:temp,
      resume:resume,
      cancelResume:cancelResume,
      cpapRequestStatus,
      patientData,
      backRoutName,
      backRoutParams,
      needAgree: isHospital || isDealer,
      agreement: "",
      isInstrument,
      changePrescription,
      maskSelectModalActive:false,
      formatType:"",
      tempDeviceSelectModalActive:false,
      preReceiptNumber,
      preKind,
      searchType:"",
      cpapAccessories,
      cpapSetItems,
      moduleList:"",
      cpapBeforeRequestDetail:null,
      // institutionId:null,
      invalidPostcode: false,
      invalidMobilePhoneNumber: false,
      invalidPhoneNumber: false,
      invalidDeliveryPostcode: false,
      invalidDeliveryPhoneNumber: false,
      note:"",
      // template message
      invalidNumberMessage,
      postcodePlaceholder,
      phonePlaceholder,
      changedCheckItems,
      changeBeforeData,
      note:"",
      prescriptionHardwareList,
    };
  },
  computed: {},
  filters: {
    getNameFilter: function(val, list){
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    }
  },
  components: {
    organizationSelectModal:OrganizationSelectModal,
    facilitySelectModal:FacilitySelectModal,
    cpapRequestDetail:CpapRequestDetail,
    officeCalenderModal:OfficeCalenderModal,
    instrumentSelectModal:InstrumentSelectModal,
    cpapMaskSelectModal:CpapMaskSelectModal
  },
  async mounted() {
    //同意文取得
    await this.getAgreementStr();
    // マスタ取得
    await this.getChoicesList();
    if(this.isHospital){
      if(this.preReceiptNumber) {
        await this.getApplication();
      }
      await this.getCpapDefaultsettings();
    }

    // 預託機の処方変更、再開用の在庫データをWEB/HTより取得
    if (this.isInstrument) {
      this.getEscrowStock();
    }
    if(this.prevRouteName == "CpapRequestDraftView") {
      var params = this.$route.params.results;
      if(params){
        this.setDraftDate(params);
      }
    }
  },
  created: function() {
    this.$validator.extend("validationCheck", {
      getMessage: field => `入力内容に誤りがあります。再度入力してください。`,
      validate: (value, indexArray) => {
        var ret = false;
        var value = indexArray[0];
        // 正規表現にカンマが含まれるとパラメタ数が変化するのでここで結合する
        var validationRule = "";

        if (value.indexOf("'") != -1) {
          // シングルコーテーションはサーバ側でSQLエラーとなる為、ここではじく
          return false;
        }

        for (var i = 1; i < indexArray.length; i++) {
          validationRule += decodeURI(indexArray[i]);
          if (i != indexArray.length - 1) {
            validationRule += ",";
          }
        }
        validationRule = validationRule.replace(/'/g, "");
        // 入力値チェック
        var regex = RegExp(validationRule);
        if (regex.test(value)) {
          ret = true;
        }
        return ret;
      }
    });
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRouteName = from.name;
    });
  },
  watch: {
    "reqParams.patient.zip"(newValue) {
      this.invalidPostcode = isNaN(Number(newValue));
    },
    "reqParams.patient.mobilePhone"(newValue) {
      this.invalidMobilePhoneNumber = isNaN(Number(newValue));
    },
    "reqParams.patient.phoneNumber"(newValue) {
      this.invalidPhoneNumber = isNaN(Number(newValue));
    },
    "reqParams.zip"(newValue) {
      this.invalidDeliveryPostcode = isNaN(Number(newValue));
    },
    "reqParams.phoneNumber"(newValue) {
      this.invalidDeliveryPhoneNumber = isNaN(Number(newValue));
    }
  }
};
</script>

<style>
</style>
<style lang="scss" scoped>
.shippingDate {
  width: 150px  !important;
}
.valueInput {
  width: 150px
}
#item-contens table.settings tr th {
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/guest/cpap/CpapRequest.vue